"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pipe_1 = require("./pipe");
var rx = require("rxjs");
var _uuidRandom = require("uuid-random");
var interop_1 = require("./interop");
var uuidRandom = interop_1.interopRequireDefault(_uuidRandom);
/**Devuelve un nuevo UUID */
function uuid() {
    return uuidRandom();
}
exports.uuid = uuid;
/**Devuelve true si todos los elementos de un arreglo encajan con el predicado */
function all(arr, pred) {
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var x = arr_1_1.value;
            if (!pred(x))
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
    var e_1, _a;
}
exports.all = all;
/**Devuelve true si todos los elementos de un arreglo son iguales. Si el arreglo esta vacío devuelve true
 * @param comparer El comparador de igualdar, por default es @see referenceEquals
 */
function allEqual(arr, comparer) {
    if (arr.length == 0)
        return true;
    var effectiveComparer = comparer || referenceEquals;
    var first = arr[0];
    for (var i = 1; i < arr.length; i++) {
        var it_1 = arr[i];
        if (!effectiveComparer(first, it_1))
            return false;
    }
    return true;
}
exports.allEqual = allEqual;
/**Devuelve true si por lo menos un elemento del arreglo encaja con el predicado, o si existe por lo menos un elemento en caso
 * de que el predicado este indefinido
 */
function any(arr, pred) {
    if (pred) {
        try {
            for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                var x = arr_2_1.value;
                if (pred(x))
                    return true;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (arr_2_1 && !arr_2_1.done && (_a = arr_2.return)) _a.call(arr_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    }
    else {
        return arr.length > 0;
    }
    var e_2, _a;
}
exports.any = any;
/**Devuelve true si el valor existe en el arreglo */
function contains(arr, value, comparer) {
    var effectiveComparer = comparer || referenceEquals;
    return any(arr, function (x) { return effectiveComparer(x, value); });
}
exports.contains = contains;
/**Devuelve true si todos los valores en @see values existen en el arreglo @see arr . Si @see values esta vacío devuelve true */
function containsAll(arr, values, comparer) {
    return all(values, function (x) { return contains(arr, x, comparer); });
}
exports.containsAll = containsAll;
/**Devuelve true si existe algun valor en @see values que exista en @see arr . Si @see values esta vacío devuelve false */
function containsAny(arr, values, comparer) {
    return any(values, function (x) { return contains(arr, x, comparer); });
}
exports.containsAny = containsAny;
/**
 * Alias para el operador ===
 * @param a
 * @param b
 */
function referenceEquals(a, b) {
    return a === b;
}
exports.referenceEquals = referenceEquals;
/**Compara dos arreglos valor por valor */
function sequenceEquals(a, b, comparer) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (a.length != b.length)
        return false;
    comparer = comparer || (function (a, b) { return a === b; });
    for (var i = 0; i < a.length; i++) {
        if (!comparer(a[i], b[i]))
            return false;
    }
    return true;
}
exports.sequenceEquals = sequenceEquals;
/**Devuelve true si 2 arreglos contienen los mismos valores, sin considerar el orden o la cantidad de veces que el mismo valor esta repetido en el arreglo
 * @param comparer Función que se usa para comparar los elementos, si no se especifica, se usa el referenceEquals
 */
function setEquals(a, b, comparer) {
    try {
        for (var a_1 = __values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()) {
            var aItem = a_1_1.value;
            if (!contains(b, aItem, comparer))
                return false;
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    try {
        for (var b_1 = __values(b), b_1_1 = b_1.next(); !b_1_1.done; b_1_1 = b_1.next()) {
            var bItem = b_1_1.value;
            if (!contains(a, bItem, comparer))
                return false;
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (b_1_1 && !b_1_1.done && (_b = b_1.return)) _b.call(b_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return true;
    var e_3, _a, e_4, _b;
}
exports.setEquals = setEquals;
function shallowEqualsCompareByRef(x) {
    var type = typeof x;
    var primTypeByRef = type == "string" || type == "boolean" || type == "number" || type == "symbol" || type == "function";
    return primTypeByRef || isPromise(x) || isObservable(x);
}
/**Compara dos objetos propiedad por propiedad */
function shallowEquals(a, b, comparer) {
    if ((typeof a) != (typeof b))
        return false;
    if (shallowEqualsCompareByRef(a) || shallowEqualsCompareByRef(b)) {
        return a === b;
    }
    if (a instanceof Date || b instanceof Date) {
        if (a instanceof Date && b instanceof Date) {
            return a.valueOf() == b.valueOf();
        }
        else
            return false;
    }
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (canBeArray(a) && canBeArray(b)) {
        return sequenceEquals(toArray(a), toArray(b), comparer);
    }
    var aKeys = Object.keys(a).map(function (x) { return x; });
    var bKeys = Object.keys(b).map(function (x) { return x; });
    if (aKeys.length != bKeys.length)
        return false;
    return sequenceEquals(aKeys.map(function (x) { return a[x]; }), aKeys.map(function (x) { return b[x]; }), comparer);
}
exports.shallowEquals = shallowEquals;
/**
 * Compara 2 objetos propiedad por propiedad, devuelve un objeto con las propiedades que son diferentes asignadas a true
 * @param a Objeto a
 * @param b Objecto b
 * @param comparer Comparador de las propiedades. Se usa por default referenceEquals
 */
function shallowDiff(a, b, comparer) {
    var eComp = comparer || referenceEquals;
    var props = pipe_1.pipe(union(Object.keys(a), Object.keys(b)), function (curr) { return curr.map(function (x) { return ({ key: x, value: a[x], otherValue: b[x], refEquals: a[x] === b[x] }); }); }, function (curr) { return curr.filter(function (x) { return !eComp(x.value, x.otherValue); }); }, function (curr) { return curr.map(function (x) { return x.key; }); }, function (curr) { return arrayToMap(curr, function (item) { return item; }, function (item) { return true; }); });
    return props;
}
exports.shallowDiff = shallowDiff;
/**Convierte un ArrayLike o Iterable en un arreglo. Si el valor ya es un arreglo devuelve el valor */
function toArray(arr) {
    if (arr instanceof Array) {
        return arr;
    }
    var isArrayLike = function (x) { return x.lenght !== undefined; };
    var ret = [];
    if (isArrayLike(arr)) {
        for (var i = 0; i < arr.length; i++) {
            ret.push(arr[i]);
        }
    }
    else {
        try {
            for (var arr_3 = __values(arr), arr_3_1 = arr_3.next(); !arr_3_1.done; arr_3_1 = arr_3.next()) {
                var a = arr_3_1.value;
                ret.push(a);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (arr_3_1 && !arr_3_1.done && (_a = arr_3.return)) _a.call(arr_3);
            }
            finally { if (e_5) throw e_5.error; }
        }
    }
    return ret;
    var e_5, _a;
}
exports.toArray = toArray;
/**Devuelve true si un objeeto se puede convertir a un arreglo utilizando la función toArray */
function canBeArray(arr) {
    return isArrayLike(arr) || hasIterationProtocol(arr);
}
exports.canBeArray = canBeArray;
/**Devuelve true si x es un array o un array like */
function isArrayLike(x) {
    return x != null && x.length !== undefined;
}
exports.isArrayLike = isArrayLike;
var hasIterationProtocol = function (variable) { return variable !== null && Symbol.iterator in Object(variable); };
function deepEquals(a, b) {
    var deep = function (a, b) { return shallowEquals(a, b, deep); };
    return deep(a, b);
}
exports.deepEquals = deepEquals;
/**Convierte un arreglo a un objeto */
function toMap(arr, key, value) {
    var ret = {};
    try {
        for (var arr_4 = __values(arr), arr_4_1 = arr_4.next(); !arr_4_1.done; arr_4_1 = arr_4.next()) {
            var x = arr_4_1.value;
            ret[key(x)] = value(x);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (arr_4_1 && !arr_4_1.done && (_a = arr_4.return)) _a.call(arr_4);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return ret;
    var e_6, _a;
}
exports.toMap = toMap;
/**Aplana una colección de colecciones */
function flatten(arr) {
    var ret = [];
    try {
        for (var arr_5 = __values(arr), arr_5_1 = arr_5.next(); !arr_5_1.done; arr_5_1 = arr_5.next()) {
            var a = arr_5_1.value;
            ret.push.apply(ret, __spread(a));
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (arr_5_1 && !arr_5_1.done && (_a = arr_5.return)) _a.call(arr_5);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return ret;
    var e_7, _a;
}
exports.flatten = flatten;
/**Devuelve el primer elemento de un arreglo o indefinido si no se encontro ninguno, opcionalmente
 * filtrado por un predicado
 */
function first(arr, pred) {
    try {
        for (var arr_6 = __values(arr), arr_6_1 = arr_6.next(); !arr_6_1.done; arr_6_1 = arr_6.next()) {
            var a = arr_6_1.value;
            if (!pred || pred(a))
                return a;
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (arr_6_1 && !arr_6_1.done && (_a = arr_6.return)) _a.call(arr_6);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return undefined;
    var e_8, _a;
}
exports.first = first;
/**
 * Devuelve el unico elemento de un arreglo que cumpla con la condición, si no se encontró ninguo o mas de uno devuelve undefined
 */
function single(arr, pred) {
    var firstItem = undefined;
    var first = false;
    try {
        for (var arr_7 = __values(arr), arr_7_1 = arr_7.next(); !arr_7_1.done; arr_7_1 = arr_7.next()) {
            var a = arr_7_1.value;
            var pass = !pred || pred(a);
            if (pass) {
                if (first) {
                    //mas de uno
                    return undefined;
                }
                else {
                    firstItem = a;
                    first = true;
                }
            }
        }
    }
    catch (e_9_1) { e_9 = { error: e_9_1 }; }
    finally {
        try {
            if (arr_7_1 && !arr_7_1.done && (_a = arr_7.return)) _a.call(arr_7);
        }
        finally { if (e_9) throw e_9.error; }
    }
    return firstItem;
    var e_9, _a;
}
exports.single = single;
/**Devuelve el ultimo elemento de un arreglo */
function last(arr) {
    return arr[arr.length - 1];
}
exports.last = last;
/**Agrupa un arreglo por una llave. Se preserva el orden original de los elementos del arreglo, segun los elementos agrupadores que aparezcan primero, tambien
 * el orden adentro del grupo es preservado
 * @param comparer Comparador de la llave por default es un shallowEquals
 */
function groupBy(arr, groupBy, comparer) {
    var ret = [];
    var comparerDefault = comparer || shallowEquals;
    var _loop_1 = function (x) {
        var key = groupBy(x);
        var firstItem = first(ret, function (x) { return comparerDefault(x.key, key); });
        if (firstItem === undefined) {
            ret.push({ key: key, items: [x] });
        }
        else {
            firstItem.items.push(x);
        }
    };
    try {
        for (var arr_8 = __values(arr), arr_8_1 = arr_8.next(); !arr_8_1.done; arr_8_1 = arr_8.next()) {
            var x = arr_8_1.value;
            _loop_1(x);
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (arr_8_1 && !arr_8_1.done && (_a = arr_8.return)) _a.call(arr_8);
        }
        finally { if (e_10) throw e_10.error; }
    }
    return ret;
    var e_10, _a;
}
exports.groupBy = groupBy;
function enumObject(obj, selector) {
    var defaultSelector = (function (key, value) { return ({ key: key, value: value }); });
    var effectiveSelector = selector || defaultSelector;
    if (selector) {
        return Object.keys(obj).map(function (key) { return selector(key, obj[key]); });
    }
    else {
        return Object.keys(obj).map(function (key) { return key; }).map(function (key) { return defaultSelector(key, obj[key]); });
    }
}
exports.enumObject = enumObject;
function arrayToMap(array, keySelector, valueSelector) {
    var defaultKeySelector = function (item) { return item.key; };
    var defaultValueSelector = function (item) { return item.value; };
    var effectiveKeySelector = keySelector || defaultKeySelector;
    var effectiveValueSelector = valueSelector || defaultValueSelector;
    var ret = {};
    try {
        for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
            var a = array_1_1.value;
            var key = effectiveKeySelector(a);
            var value = effectiveValueSelector(a);
            ret[key] = value;
        }
    }
    catch (e_11_1) { e_11 = { error: e_11_1 }; }
    finally {
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        }
        finally { if (e_11) throw e_11.error; }
    }
    return ret;
    var e_11, _a;
}
exports.arrayToMap = arrayToMap;
/**
 * Aplica una función a cada propiedad de un objeto, conservando los keys
 * @param obj Objeto a mapear
 * @param map Función que toma el valor y el "key" y devuelve el nuevo valor
 */
function mapObject(obj, map) {
    var ret = {};
    for (var key in obj) {
        var value = obj[key];
        ret[key] = map(value, key);
    }
    return ret;
}
exports.mapObject = mapObject;
/**
 * Filtra las propiedades de un objeto
 * @param obj Objeto que se va a filtrar
 * @param pred Predicado que va a determinar que propiedades si se van a conservar
 */
function filterObject(obj, pred) {
    var ret = {};
    for (var key in obj) {
        var value = obj[key];
        if (pred(value, key)) {
            ret[key] = value;
        }
    }
    return ret;
}
exports.filterObject = filterObject;
/**
 * Quita un conjunto de propiedades de un objeto
 * @param obj El objeto original
 * @param keys Las propiedades que se desean quitar
 */
function omit(obj, keys) {
    return filterObject(obj, function (value, key) { return !contains(keys, key); });
}
exports.omit = omit;
/**Quita las propiedades que esten indefinidas en un objeto */
function omitUndefined(obj) {
    return filterObject(obj, function (value) { return value !== undefined; });
}
exports.omitUndefined = omitUndefined;
/**Devuelve un objeto son solo ciertas propiedades del objeto incluidas. Si se escoge una propiedad que no existe en el objeto esta no estará incluida en el objeto devuelto */
function pick(obj) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    var ret = {};
    try {
        for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
            var key = props_1_1.value;
            if (key in obj) {
                ret[key] = obj[key];
            }
        }
    }
    catch (e_12_1) { e_12 = { error: e_12_1 }; }
    finally {
        try {
            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
        }
        finally { if (e_12) throw e_12.error; }
    }
    return ret;
    var e_12, _a;
}
exports.pick = pick;
/**Intercambia 2 elementos de un arreglo, si los indices dados estan afuera del arreglo, lanza una excepción */
function swapItems(array, a, b) {
    var inside = function (x) { return x >= 0 && x < array.length; };
    if (!inside(a) || !inside(b))
        throw new Error("Indice fuera de rango");
    return array.map(function (x, i, arr) {
        return i == a ? arr[b] :
            i == b ? arr[a] :
                arr[i];
    });
}
exports.swapItems = swapItems;
/**Mueve un elemento del arreglo de un indice a otro, note que no es igual a swapItems ya que al mover un elemento se conserva el orden de todos los de más elemento, esto no ocurre con el swap que
 * simplemente intercambia de posición 2 elementos. Si los indices estan fuera de rango lanza uan excepción
*/
function moveItem(array, sourceIndex, destIndex) {
    var inside = function (x) { return x >= 0 && x < array.length; };
    if (!inside(sourceIndex) || !inside(destIndex))
        throw new Error("Indice fuera de rango");
    //Si los valroes son iguales devuelve el arreglo tal cual
    if (sourceIndex == destIndex)
        return array;
    //Dirección del movimiento, puede ser -1 o +1
    var dir = Math.sign(destIndex - sourceIndex);
    var min = Math.min(sourceIndex, destIndex);
    var max = Math.max(sourceIndex, destIndex);
    return array.map(function (x, i, arr) {
        return (i < min || i > max) ? x :
            (i == destIndex) ? arr[sourceIndex] :
                arr[i + dir];
    });
}
exports.moveItem = moveItem;
/**Mueve un elemento hacia array o hacia abajo, si el elemento no se puede mover ya que esta en el borde del arreglo devuelve el arreglo tal cual */
function upDownItem(array, index, direction) {
    if ((index == 0 && direction == "up") || (index == array.length - 1 && direction == "down")) {
        return array;
    }
    else {
        return moveItem(array, index, index + (direction == "up" ? -1 : +1));
    }
}
exports.upDownItem = upDownItem;
function promiseAllObj(obj) {
    var keys = Object.keys(obj);
    var values = keys.map(function (key) { return obj[key]; });
    var all = Promise.all(values);
    var ret = all.then(function (arr) { return arr.map(function (value, index) { return ({ key: keys[index], value: value }); }); }).then(function (x) { return arrayToMap(x); });
    return ret;
}
exports.promiseAllObj = promiseAllObj;
/**Convierte un objeto de observables a un observable de objetos, el primer elemento del observable resultante se da cuando todos los observables del objeto lanzan el primer valor */
function objRxToRxObj(obj) {
    var keys = Object.keys(obj);
    ;
    var values = keys.map(function (key) { return obj[key].map(function (x) { return ({
        value: x,
        key: key
    }); }); });
    var combine = rx.Observable.combineLatest(values).map(function (x) { return arrayToMap(x); });
    return combine;
}
exports.objRxToRxObj = objRxToRxObj;
/**Convierte una promesa de un objeto a un objeto de promesas
 * @param include Nombres de las propiedades que se desean incluir en el objeto resultante
 */
function awaitObj(obj, include) {
    var ret = pipe_1.pipe(include, function (inc) { return filterObject(inc, function (x) { return !!x; }); }, function (inc) { return mapObject(inc, function (value, key) { return obj.then(function (x) { return x[key]; }); }); });
    return ret;
}
exports.awaitObj = awaitObj;
/**Devuelve todos los elementos de un arreglo que no estan repetidos, respetando el orden original en el que aparecen primero.
 * @param comparer Comparador que determina si 2 elementos son iguales. Se usa el operador ===
*/
function unique(arr, comparer) {
    return groupBy(arr, function (x) { return x; }, referenceEquals).map(function (x) { return x.key; });
}
exports.unique = unique;
/**Devuelve todos los elementos de todos los arreglos que no esten repetidos.
 * Conserva el orden pero no los elementos repetidos
 */
function union() {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arr[_i] = arguments[_i];
    }
    return unique(concat.apply(void 0, __spread(arr)));
}
exports.union = union;
/**
 * Devuelve todos los elementos en A que su llave no se encuentre en B las llaves de B y todos los elementos en B, en ese orden
 * esto equivale a unir los conjuntos A+B, pero dandole prioridad a los elementos en B si es que esa llave se encuentra en los dos conjuntos.
 * Esto se puede ver como una operacion de INSERT OR UPDATE en A
 * @param comparer Comparador de la llave. Es @see deepEquals por default
 */
function unionKey(a, b, getKey, comparer) {
    var effComparer = comparer || deepEquals;
    var result = [];
    //Obtiene todas las claves en B
    var bKeys = b.map(getKey);
    try {
        //Todos los elementos en A que no esten en B
        for (var a_2 = __values(a), a_2_1 = a_2.next(); !a_2_1.done; a_2_1 = a_2.next()) {
            var aItem = a_2_1.value;
            var aKey = getKey(aItem);
            if (!contains(bKeys, aKey, effComparer)) {
                result.push(aItem);
            }
        }
    }
    catch (e_13_1) { e_13 = { error: e_13_1 }; }
    finally {
        try {
            if (a_2_1 && !a_2_1.done && (_a = a_2.return)) _a.call(a_2);
        }
        finally { if (e_13) throw e_13.error; }
    }
    //Todos los elementos en B
    result.push.apply(result, __spread(b));
    return result;
    var e_13, _a;
}
exports.unionKey = unionKey;
/**Devuelve todos los elementos en A que no esten en B. Es la operacion A-B de conjuntos. Conserva el orden y los elementos repetidos de A */
function exclude(a, b, comparer) {
    var comparerEff = comparer && (function (b, a) { return comparer(a, b); });
    return a.filter(function (aItem) { return !contains(b, aItem, comparerEff); });
}
exports.exclude = exclude;
/**Devuelve todos los elementos en "items" tal que su key no se encuentre una o mas veces en "keys". Conserva el orden original de "items".
 * @param keySelector Obtiene la clave de un elemento
 * @param comparer Comparedor de igualdad. Por default se usa el shallowEquals
 */
function excludeKeys(items, keys, keySelector, comparer) {
    var comparerEff = comparer || shallowEquals;
    return exclude(items, keys, function (a, b) { return comparerEff(keySelector(a), b); });
}
exports.excludeKeys = excludeKeys;
/**Pega todos los elementos de los arreglos */
function concat() {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arr[_i] = arguments[_i];
    }
    return arr.reduce(function (acum, curr) { return __spread(acum, curr); }, []);
}
exports.concat = concat;
/**Filtra el arreglo sólo si condition == true, si es false devuelve el arreglo tal cual */
function filterIf(arr, predicate, condition) {
    return condition ? arr.filter(predicate) : arr;
}
exports.filterIf = filterIf;
/**Dado un arreglo de keys, para cada key mapea a el elemento que le corresponde.
 * Si existen varios elementos con la misma clave, cuando se encuentre esa clave se devolverá el primer elemento en el arreglo values con esa clave
 * @param keys Claves que se van a mapear
 * @param values Valores en los que se va a buscar para cada clave, el valor que tiene esa clave
 * @param keySelector Obtener la clave de un elemento
 * @param keyComparer Comparador que se usará para determinar si dos claves son iguales. Por default se usa el shallowEquals
 */
function mapKeys(keys, values, keySelector, keyComparer) {
    var effectiveKeyComparer = keyComparer || shallowEquals;
    return keys.map(function (key) { return first(values, function (value) { return shallowEquals(key, keySelector(value)); }); });
}
exports.mapKeys = mapKeys;
/**Devuelve todos los elementos en "a" que se encuentren también en "b". Conserva el orden original de "a"
 * @param comparer Comparedor de igualdad. Por default se usa el referenceEquals
 */
function intersect(a, b, comparer) {
    return intersectKeys(a, b, function (x) { return x; }, comparer || referenceEquals);
}
exports.intersect = intersect;
/**Devuelve true si SET contiene todos los elementos en SUBSET. Si los conjuntos son iguales devuelve true.
 * Si los dos arreglos estan vacios devuelve true
 */
function isSubset(set, subset, comparer) {
    //Si por lo menos un elemento en subset no existe en set, ya no es un subset
    return !any(subset, function (x) { return !contains(set, x); });
}
exports.isSubset = isSubset;
/**Devuelve todos los elementos en "items" tal que su key se encuentre una o mas veces en "keys". Conserva el orden original de "items".
 * @param keySelector Obtiene la clave de un elemento
 * @param comparer Comparedor de igualdad. Por default se usa el shallowEquals
 */
function intersectKeys(items, keys, keySelector, comparer) {
    return items.filter(function (item) { return contains(keys, keySelector(item), comparer || shallowEquals); });
}
exports.intersectKeys = intersectKeys;
/**Devuelve un rango de numeros */
function range(start, count, step) {
    var ret = [];
    step = step || 1;
    var end = start + count * step;
    for (var i = start; i < end; i += step) {
        ret.push(i);
    }
    return ret;
}
exports.range = range;
/**
 * Devuelve un nuevo arreglo con todo el arreglo original mas el elemento al final
 */
function push(arr, item) {
    return __spread(arr, [item]);
}
exports.push = push;
/**
 * Remplaza todos los valores del arreglo que cumplan con cierta condicion
 */
function replace(arr, condition, newValue) {
    return arr.map(function (x, i) { return condition(x, i) ? newValue : x; });
}
exports.replace = replace;
/**Elimina un elemento del arreglo */
function remove(arr, item) {
    return arr.filter(function (x) { return x != item; });
}
exports.remove = remove;
/**
 * Combina varias funciones comparadores que pueden ser usadas para alimentar a la función sort. Se le da prioridad a los primeros comparadores,
 * si un comparador devuelve 0, entonces se evalue el segundo
 * @param comparers
 */
function combineComparers() {
    var comparers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        comparers[_i] = arguments[_i];
    }
    return function (a, b) {
        try {
            for (var comparers_1 = __values(comparers), comparers_1_1 = comparers_1.next(); !comparers_1_1.done; comparers_1_1 = comparers_1.next()) {
                var comp = comparers_1_1.value;
                var result = comp(a, b);
                if (result != 0)
                    return result;
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (comparers_1_1 && !comparers_1_1.done && (_a = comparers_1.return)) _a.call(comparers_1);
            }
            finally { if (e_14) throw e_14.error; }
        }
        return 0;
        var e_14, _a;
    };
}
exports.combineComparers = combineComparers;
/**Comparador de ordenamiento por default. Si a es mayor que b devuelve 1, si es menor -1  */
function defaultComparer(a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === null && b === undefined) {
        return 1;
    }
    else if (a === undefined && b === null) {
        return -1;
    }
    else
        return a > b ? 1 : a < b ? -1 : 0;
}
exports.defaultComparer = defaultComparer;
/**Ordena un arreglo de forma estable, a diferencia de con array.sort el arreglo original no es modificado
 * @param comparers Comparadores de ordenamiento, se le da precedencia al primero. Si no se especifica ninguno se usará el comparador por default
 */
function sort(arr) {
    var comparers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        comparers[_i - 1] = arguments[_i];
    }
    comparers = comparers.length == 0 ? [defaultComparer] : comparers;
    var toEffComparer = function (func) { return function (a, b) { return func(a.value, b.value); }; };
    //Comparamos tambien por indice
    var effComparers = __spread(comparers.map(toEffComparer), [
        function (a, b) { return a.index - b.index; }
    ]);
    var effectiveComparer = combineComparers.apply(void 0, __spread(effComparers));
    var copy = arr.map(function (x, i) { return ({ value: x, index: i }); });
    copy.sort(effectiveComparer);
    var ret = copy.map(function (x) { return x.value; });
    return ret;
}
exports.sort = sort;
/**
 * Ordena un arreglo de forma estable segun ciertas claves seleccionadas usando el comparador por default
 */
function orderBy(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comparers = keySelectors.map(function (selector) { return function (a, b) { return +defaultComparer(selector(a), selector(b)); }; });
    return sort.apply(void 0, __spread([arr], comparers));
}
exports.orderBy = orderBy;
/**Ordena un arreglo de forma estable y descendiente segun ciertas claves seleccionadas usando el comparador por default */
function orderByDesc(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comparers = keySelectors.map(function (selector) { return function (a, b) { return -defaultComparer(selector(a), selector(b)); }; });
    return sort.apply(void 0, __spread([arr], comparers));
}
exports.orderByDesc = orderByDesc;
/**Convierte un observable de T, de Promise<T> o de Observable<T> a un observable de <T>, efectivamente aplanando un observable anidado en uno desanidado */
function rxFlatten(observable) {
    var obsOfObs = observable.map(function (x) { return toObservable(x); });
    return obsOfObs.concatAll();
}
exports.rxFlatten = rxFlatten;
function toObservable(value) {
    if (value instanceof rx.Observable) {
        return value;
    }
    else {
        return rx.Observable.fromPromise(Promise.resolve(value));
    }
}
exports.toObservable = toObservable;
/**Toma los primeros N elementos del arreglo */
function take(arr, count) {
    var ret = [];
    for (var i = 0; i < Math.min(arr.length, count); i++) {
        ret.push(arr[i]);
    }
    return ret;
}
exports.take = take;
/**Obtiene le primer elemento mapeado de un arreglo o undefined */
function firstMap(arr, predicate, map) {
    var f = first(arr, predicate);
    return f && map(f);
}
exports.firstMap = firstMap;
/**Devuelve true si existiran duplicados en caso de editar un elemento de un arreglo
 * @param arr Arreglo
 * @param oldValueRef Valor anterior del arreglo
 * @param newValue Nuevo valor del arreglo
 */
function duplicatesOnEdit(arr, oldValue, newValue, keySelector) {
    var comparer = function (a, b) { return shallowEquals(keySelector(a), keySelector(b)); };
    var foundOldValue = false;
    try {
        for (var arr_9 = __values(arr), arr_9_1 = arr_9.next(); !arr_9_1.done; arr_9_1 = arr_9.next()) {
            var item = arr_9_1.value;
            if (comparer(item, newValue)) {
                if ((comparer(item, oldValue) && !foundOldValue)) {
                    foundOldValue = true;
                }
                else {
                    return true;
                }
            }
        }
    }
    catch (e_15_1) { e_15 = { error: e_15_1 }; }
    finally {
        try {
            if (arr_9_1 && !arr_9_1.done && (_a = arr_9.return)) _a.call(arr_9);
        }
        finally { if (e_15) throw e_15.error; }
    }
    return false;
    var e_15, _a;
}
exports.duplicatesOnEdit = duplicatesOnEdit;
/**
 * Devuelve true si existirán duplicados en caso de agregar un elemento a un arreglo que es equivalente a saber
 * si ese elemento esta contenido en el arreglo
 * @param arr
 * @param newValue
 * @param comparer  Se usa el shallow equals por default
 */
function duplicatesOnAdd(arr, newValue, keySelector) {
    var comparer = function (a, b) { return shallowEquals(keySelector(a), keySelector(b)); };
    return contains(arr, newValue, comparer);
}
exports.duplicatesOnAdd = duplicatesOnAdd;
/**Devuelve true si x tiene el metodo then, lo que indica que es una promesa */
function isPromise(x) {
    return x != null && (typeof x.then) == "function";
}
exports.isPromise = isPromise;
/**Devuelve true si x es un observable */
function isObservable(x) {
    return x instanceof rx.Observable;
}
exports.isObservable = isObservable;
/**Devuelve true si x es un array */
function isArray(x) {
    return x instanceof Array;
}
exports.isArray = isArray;
/**Mapea el valor actual y el anterior de un observable */
function mapPreviousRx(obs, startWith) {
    var ret = obs
        .map(function (x) { return ({ prev: startWith, curr: x }); })
        .scan(function (acc, val) { return ({ prev: acc.curr, curr: val.curr }); });
    return ret;
}
exports.mapPreviousRx = mapPreviousRx;
/**Mapea cada elemento de un arreglo tomando en cuenta el elemento anterior */
function mapPrevious(items, map, initial) {
    var prev = initial;
    var ret = [];
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var it_2 = items_1_1.value;
            ret.push(map(prev, it_2));
            prev = it_2;
        }
    }
    catch (e_16_1) { e_16 = { error: e_16_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_16) throw e_16.error; }
    }
    return ret;
    var e_16, _a;
}
exports.mapPrevious = mapPrevious;
/**Calcula un agregado corrido para cada elemento de un arreglo */
function runningTotal(items, seed, reduceState, map) {
    var ret = [];
    var state = seed;
    try {
        for (var items_2 = __values(items), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
            var it_3 = items_2_1.value;
            var proj = reduceState(state, it_3);
            state = proj;
            var output = map(state, it_3);
            ret.push(output);
        }
    }
    catch (e_17_1) { e_17 = { error: e_17_1 }; }
    finally {
        try {
            if (items_2_1 && !items_2_1.done && (_a = items_2.return)) _a.call(items_2);
        }
        finally { if (e_17) throw e_17.error; }
    }
    return ret;
    var e_17, _a;
}
exports.runningTotal = runningTotal;
/**Mapea y aplana una colección. Es equivalente a  flatten(items.map(map)) */
function mapMany(items, map) {
    var result = [];
    try {
        for (var items_3 = __values(items), items_3_1 = items_3.next(); !items_3_1.done; items_3_1 = items_3.next()) {
            var x = items_3_1.value;
            var mapResult = map(x);
            result.push.apply(result, __spread(mapResult));
        }
    }
    catch (e_18_1) { e_18 = { error: e_18_1 }; }
    finally {
        try {
            if (items_3_1 && !items_3_1.done && (_a = items_3.return)) _a.call(items_3);
        }
        finally { if (e_18) throw e_18.error; }
    }
    return result;
    var e_18, _a;
}
exports.mapMany = mapMany;
/**Convierte un objeto de arreglos a un arreglo de objetos, si el objeto de arreglos esta vacio, devuelve un arreglo vacio*/
function zip(data) {
    //Checa que todo los arreglos tengan la misma longitud
    var lengths = enumObject(data).map(function (x) { return x.value.length; });
    if (!allEqual(lengths)) {
        throw new Error("Todos los arreglos deben de tener la misma longitud");
    }
    if (lengths.length == 0)
        return [];
    var count = lengths[0];
    var ret = [];
    var _loop_2 = function (i) {
        var fila = mapObject(data, function (value, key) { return value[i]; });
        ret.push(fila);
    };
    for (var i = 0; i < count; i++) {
        _loop_2(i);
    }
    return ret;
}
exports.zip = zip;
/**A una cadena que representa un numero entero, aplica el separador de miles */
function aplicarSepMiles(intpart, sep) {
    if (sep === void 0) { sep = ","; }
    if (intpart.length < 4)
        return intpart;
    var start = intpart.length % 3;
    var ret = intpart.substr(0, start);
    for (var i = start; i < intpart.length; i += 3) {
        var subpart = intpart.substr(i, 3);
        ret += i == 0 ? subpart : (sep + subpart);
    }
    return ret;
}
/**
 * Formatea un número
 * @param number El numero
 * @param integer Cantidad de zeros a la izquierda en la parte entera
 * @param decimals Cantidad de zeros a la derecha en la parte desimal
 * @param thousep Usar separador de miles. Por default es false
 * @param prefix Prefijo del numero, ejemplo $ o %. Por default es ""
 */
function formatNumber(number, integer, decimals, thousep, prefix) {
    if (integer === void 0) { integer = 0; }
    if (decimals === void 0) { decimals = 0; }
    if (thousep === void 0) { thousep = false; }
    if (prefix === void 0) { prefix = ""; }
    if (number == null)
        return "";
    number = Number(number);
    var zeroes = "00000000000000000000";
    var sign = number < 0 ? "-" : "";
    var x = Math.abs(number);
    var int = Math.trunc(x);
    var frac = x - int;
    var intText = "" + int;
    var intZeroStr = zeroes + intText;
    var intPartSinSep = intZeroStr.substr(intZeroStr.length - Math.max(integer, intText.length));
    var intPart = thousep ? aplicarSepMiles(intPartSinSep) : intPartSinSep;
    if (decimals == 0)
        return sign + prefix + intPart;
    var fracText = "" + Math.trunc(Math.round(frac * 1000 * Math.pow(10, decimals)) / 1000);
    var leftFracZeroes = zeroes.substr(0, decimals - fracText.length);
    var fracZeroStr = leftFracZeroes + fracText + zeroes;
    var fracPart = fracZeroStr.substring(0, decimals);
    return sign + prefix + intPart + "." + fracPart;
}
exports.formatNumber = formatNumber;
function nullOrEmpty(x) {
    return x == null || x == "";
}
exports.nullOrEmpty = nullOrEmpty;
var monthNames = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
/**Formatea una fecha
 * @param fullDateTime true o false para indicar si mostrar las horas o no. Por default es undefined e implicar que se mostraran las horas si el valor tiene componente de horas, si no, se mostrará sólo la fecha
 */
function formatDate(x, fullDateTime) {
    if (x == null)
        return "";
    x = new Date(x);
    var year = formatNumber(x.getFullYear(), 4);
    var month = monthNames[x.getMonth()];
    var day = formatNumber(x.getDate(), 2);
    var hours = formatNumber(x.getHours(), 2);
    var minutes = formatNumber(x.getMinutes(), 2);
    //True si se debe de mostrar hora y fecha, si no, solo la fecha
    var effFull = fullDateTime == null ? (hours != "00" || minutes != "00") : fullDateTime;
    var dateStr = day + "/" + month + "/" + year;
    if (effFull) {
        var hourStr = hours + ":" + minutes;
        return dateStr + " " + hourStr;
    }
    else {
        return dateStr;
    }
}
exports.formatDate = formatDate;
/**Formatea una fecha de tal manera que sea compatible con el excel */
function formatDateExcel(x) {
    var f = function (x) { return formatNumber(x, 2); };
    var f4 = function (x) { return formatNumber(x, 4); };
    return f4(x.getFullYear()) + "-" + f(x.getMonth() + 1) + "-" + f(x.getDate()) + " " + f(x.getHours()) + ":" + f(x.getMinutes()) + ":" + f(x.getSeconds());
}
exports.formatDateExcel = formatDateExcel;
/**Devuelve una copia de una función. Respeta las propiedades agregadas a la función */
function cloneFunction(func) {
    var ret = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return func.apply(void 0, __spread(args));
    };
    var keys = Object.keys(func);
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            ret[key] = func[key];
        }
    }
    catch (e_19_1) { e_19 = { error: e_19_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_19) throw e_19.error; }
    }
    return ret;
    var e_19, _a;
}
exports.cloneFunction = cloneFunction;
var bindOrigFuncKey = "_keautils_bindFunction_origFunctions";
/**Aplica un Function.bind respetando las propiedades agregadas a la función. Tambien se almacena la funcion original de tal manera que se puede devolver al estado original */
function bindFunction(func, thisArg) {
    var argArray = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        argArray[_i - 2] = arguments[_i];
    }
    var keys = Object.keys(func);
    var ret = func.bind.apply(func, __spread([thisArg], argArray));
    try {
        for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
            var key = keys_2_1.value;
            ret[key] = func[key];
        }
    }
    catch (e_20_1) { e_20 = { error: e_20_1 }; }
    finally {
        try {
            if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
        }
        finally { if (e_20) throw e_20.error; }
    }
    ;
    ret[bindOrigFuncKey] = ret[bindOrigFuncKey] || [];
    ret[bindOrigFuncKey] = __spread(ret[bindOrigFuncKey], [func]);
    return ret;
    var e_20, _a;
}
exports.bindFunction = bindFunction;
/**Deshace un bind aplicado con bindFunction. Un bind aplicado con Function.bind directamente no se puede deshacer. Si al argumento no se le fue aplicado un bind devuelve undefined */
function unbindFunction(func) {
    if (!func[bindOrigFuncKey]) {
        return undefined;
    }
    var arr = func[bindOrigFuncKey];
    return arr[arr.length - 1];
}
exports.unbindFunction = unbindFunction;
/**Devuelve una promesa que se resuelve en cierto tiempo*/
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
exports.delay = delay;
/**Una funcion que siempre lanza una excepción al ser llamada. Sirve para implementar cases exhaustivos, tal como esta descrito en https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript*/
function assertUnreachable(x) {
    throw new Error("Se llamó a la función assertUnreachable, esto puede indicar un tipo inesperado en una discriminación de tips");
}
exports.assertUnreachable = assertUnreachable;
/**Realiza una busqueda binaria en un arreglo, devuelve el indice del elemento mas cercano y si fue encontrado o no el elemento.
 * En caso de que no encaje devuelve el indice del ultimo elemento que es menor que el valor de busqueda. Si ningun elemento del arreglo es menor al valor de busqueda devuelve -1.
 */
function binarySearch(arr, keySelector, value, comparer) {
    var effComparer = comparer || defaultComparer;
    var minIndex = 0;
    var maxIndex = arr.length - 1;
    var currentIndex = 0;
    var currentElement;
    while (minIndex <= maxIndex) {
        currentIndex = (minIndex + maxIndex) / 2 | 0;
        currentElement = keySelector(arr[currentIndex]);
        var comp = effComparer(currentElement, value);
        if (comp < 0) {
            minIndex = currentIndex + 1;
        }
        else if (comp > 0) {
            maxIndex = currentIndex - 1;
        }
        else {
            return { index: currentIndex, match: true };
        }
    }
    return { index: minIndex - 1, match: false };
}
exports.binarySearch = binarySearch;
/**
 * Para todos los pares de elemento en left y right que cumplen con el where, devuelve ese par de elementos
 * Se respeta el orden del arreglo @see left
 * Este algoritmo corre con complejidad O^2 o NM donde N es la cantidad de elementos en left y M la cantidad de elementos en right
 * @param left Arreglo izquierdo
 * @param right Arreglo derecho
 * @param where Condicion para filtrar el producto cartesiano
 */
function innerJoin(left, right, where) {
    var ret = [];
    try {
        for (var left_1 = __values(left), left_1_1 = left_1.next(); !left_1_1.done; left_1_1 = left_1.next()) {
            var l = left_1_1.value;
            try {
                for (var right_1 = __values(right), right_1_1 = right_1.next(); !right_1_1.done; right_1_1 = right_1.next()) {
                    var r = right_1_1.value;
                    if (where(l, r)) {
                        ret.push({ left: l, right: r });
                    }
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (right_1_1 && !right_1_1.done && (_a = right_1.return)) _a.call(right_1);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
    }
    catch (e_22_1) { e_22 = { error: e_22_1 }; }
    finally {
        try {
            if (left_1_1 && !left_1_1.done && (_b = left_1.return)) _b.call(left_1);
        }
        finally { if (e_22) throw e_22.error; }
    }
    return ret;
    var e_22, _b, e_21, _a;
}
exports.innerJoin = innerJoin;
/**
 * Para todos los elementos en left y right que cumplen con el where, devuelve ese par de elementos. Si para
 * cierto elemento en left ningun par de elementos (left, right) cumple con la condicion, devuelve un par solo con el valor (left) asignado y el
 * (right) en undefined. Esto hace que todos los elementos en left sean incluidos en el resultado final incondicionalmente por lo menos una vez * Este algoritmo corre con complejidad O^2 o NM donde N es la cantidad de elementos en left y M la cantidad de elementos en right
 * @param left Arreglo izquierdo
 * @param right Arreglo derecho
 * @param where Condicion para filtrar el producto cartesiano
 */
function leftJoin(left, right, where) {
    var ret = [];
    try {
        for (var left_2 = __values(left), left_2_1 = left_2.next(); !left_2_1.done; left_2_1 = left_2.next()) {
            var l = left_2_1.value;
            var anyRight = false;
            try {
                for (var right_2 = __values(right), right_2_1 = right_2.next(); !right_2_1.done; right_2_1 = right_2.next()) {
                    var r = right_2_1.value;
                    if (where(l, r)) {
                        anyRight = true;
                        ret.push({ left: l, right: r });
                    }
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (right_2_1 && !right_2_1.done && (_a = right_2.return)) _a.call(right_2);
                }
                finally { if (e_23) throw e_23.error; }
            }
            if (!anyRight) {
                ret.push({ left: l });
            }
        }
    }
    catch (e_24_1) { e_24 = { error: e_24_1 }; }
    finally {
        try {
            if (left_2_1 && !left_2_1.done && (_b = left_2.return)) _b.call(left_2);
        }
        finally { if (e_24) throw e_24.error; }
    }
    return ret;
    var e_24, _b, e_23, _a;
}
exports.leftJoin = leftJoin;
/**Combina dos rutas. Combina correctamente las rutas con ./ y ../
 * @param ruta base
 * @param path Ruta actual
 * @param pathChar Caracter que divide a la ruta
 * @param prefix True para iniciar la ruta con el caracter de ruta, false para no iniciar, indefinido para dejarlo tal cual. Por default is true
 * @param postfix True para terminar la ruta con el caracter de ruta, false para quitarlo, indefinido para dejarlo tal cual
 */
function combinePath(basePath, path, pathChar, prefix, postfix) {
    if (pathChar === void 0) { pathChar = "/"; }
    if (prefix === void 0) { prefix = true; }
    if (postfix === void 0) { postfix = false; }
    function trim(s) {
        var start = s.startsWith(pathChar) ? 1 : 0;
        var end = s.endsWith(pathChar) ? (s.length - 1) : s.length;
        return s.substr(start, end - start);
    }
    var basePathTrim = trim(basePath);
    var pathTrim = trim(path);
    var basePathParts = basePathTrim.split(pathChar);
    var pathParts = pathTrim.split(pathChar);
    var relative = pathParts.length > 0 && pathParts[0].startsWith(".");
    var current = relative ? basePathTrim : pathTrim;
    var firstTextPart = false;
    if (relative) {
        try {
            for (var pathParts_1 = __values(pathParts), pathParts_1_1 = pathParts_1.next(); !pathParts_1_1.done; pathParts_1_1 = pathParts_1.next()) {
                var part = pathParts_1_1.value;
                if (part == "." || part == "..") {
                    if (firstTextPart)
                        throw new Error("La ruta no puede contener partes con . o .. despues de una parte de texto");
                }
                if (part == ".") {
                    //No hay que hacer nada
                }
                else if (part == "..") {
                    var currentParts = current.split("/");
                    current = currentParts.slice(0, currentParts.length - 1).join(pathChar);
                }
                else {
                    firstTextPart = true;
                    current += current == "" ? part : (pathChar + part);
                }
            }
        }
        catch (e_25_1) { e_25 = { error: e_25_1 }; }
        finally {
            try {
                if (pathParts_1_1 && !pathParts_1_1.done && (_a = pathParts_1.return)) _a.call(pathParts_1);
            }
            finally { if (e_25) throw e_25.error; }
        }
    }
    var originalStartPathChar = (relative ? basePath : path).startsWith(pathChar);
    var originalEndsWithPathChar = path.endsWith(pathChar);
    //Asignar el prefijo y postfijo
    if (prefix == true || (prefix === undefined && originalStartPathChar)) {
        current = pathChar + current;
    }
    if (postfix == true || (postfix === undefined && originalEndsWithPathChar)) {
        current = current + pathChar;
    }
    return current;
    var e_25, _a;
}
exports.combinePath = combinePath;
/**Suma un arreglo de numeros. Si el arreglo esta vacío devuelve 0.
 * Los valores nulos o indefinidos son ignorados en la suma
 */
function sum(arr) {
    return arr.filter(function (x) { return x != null; }).map(function (x) { return x; }).reduce(function (a, b) { return a + b; }, 0);
}
exports.sum = sum;
/**Convierte un observable a una promesa que se resuelve en el siguiente onNext del observable, esto es diferente a la función
 * @see rx.Observable.toPromise() que se resueve hasta que el observable es completado
*/
function nextToPromise(obs) {
    return new Promise(function (resolve, reject) { return obs.subscribe(resolve, reject); });
}
exports.nextToPromise = nextToPromise;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9naWMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbG9naWMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQkFBOEI7QUFDOUIseUJBQTJCO0FBQzNCLHlDQUEyQztBQUUzQyxxQ0FBa0Q7QUFDbEQsSUFBTSxVQUFVLEdBQUcsK0JBQXFCLENBQUMsV0FBVyxDQUFRLENBQUM7QUFDN0QsNEJBQTRCO0FBQzVCO0lBQ0ksT0FBTyxVQUFVLEVBQUUsQ0FBQztBQUN4QixDQUFDO0FBRkQsb0JBRUM7QUFFRCxpRkFBaUY7QUFDakYsYUFBdUIsR0FBUSxFQUFFLElBQXVCOztRQUNwRCxLQUFnQixJQUFBLFFBQUEsU0FBQSxHQUFHLENBQUEsd0JBQUE7WUFBZCxJQUFNLENBQUMsZ0JBQUE7WUFDUixJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztnQkFDUixPQUFPLEtBQUssQ0FBQztTQUNwQjs7Ozs7Ozs7O0lBQ0QsT0FBTyxJQUFJLENBQUM7O0FBQ2hCLENBQUM7QUFORCxrQkFNQztBQUVEOztHQUVHO0FBQ0gsa0JBQTRCLEdBQVEsRUFBRSxRQUFrQztJQUNwRSxJQUFJLEdBQUcsQ0FBQyxNQUFNLElBQUksQ0FBQztRQUFFLE9BQU8sSUFBSSxDQUFDO0lBQ2pDLElBQU0saUJBQWlCLEdBQUcsUUFBUSxJQUFJLGVBQWUsQ0FBQztJQUN0RCxJQUFNLEtBQUssR0FBRyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDckIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDakMsSUFBTSxJQUFFLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ2xCLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxLQUFLLEVBQUUsSUFBRSxDQUFDO1lBQzdCLE9BQU8sS0FBSyxDQUFDO0tBQ3BCO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDaEIsQ0FBQztBQVZELDRCQVVDO0FBRUQ7O0dBRUc7QUFDSCxhQUF1QixHQUFRLEVBQUUsSUFBd0I7SUFDckQsSUFBSSxJQUFJLEVBQUU7O1lBQ04sS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO2dCQUFkLElBQU0sQ0FBQyxnQkFBQTtnQkFDUixJQUFJLElBQUksQ0FBQyxDQUFDLENBQUM7b0JBQUUsT0FBTyxJQUFJLENBQUM7YUFDNUI7Ozs7Ozs7OztRQUNELE9BQU8sS0FBSyxDQUFDO0tBQ2hCO1NBQU07UUFDSCxPQUFPLEdBQUcsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO0tBQ3pCOztBQUNMLENBQUM7QUFURCxrQkFTQztBQUVELG9EQUFvRDtBQUNwRCxrQkFBaUMsR0FBUyxFQUFFLEtBQVMsRUFBRSxRQUFvQztJQUN2RixJQUFNLGlCQUFpQixHQUFHLFFBQVEsSUFBSSxlQUFlLENBQUM7SUFDdEQsT0FBTyxHQUFHLENBQUMsR0FBRyxFQUFFLFVBQUEsQ0FBQyxJQUFJLE9BQUEsaUJBQWlCLENBQUMsQ0FBQyxFQUFFLEtBQUssQ0FBQyxFQUEzQixDQUEyQixDQUFDLENBQUM7QUFDdEQsQ0FBQztBQUhELDRCQUdDO0FBRUQsZ0lBQWdJO0FBQ2hJLHFCQUErQixHQUFRLEVBQUUsTUFBVyxFQUFFLFFBQWtDO0lBQ3BGLE9BQU8sR0FBRyxDQUFDLE1BQU0sRUFBRSxVQUFBLENBQUMsSUFBSSxPQUFBLFFBQVEsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxFQUExQixDQUEwQixDQUFDLENBQUM7QUFDeEQsQ0FBQztBQUZELGtDQUVDO0FBRUQsMEhBQTBIO0FBQzFILHFCQUErQixHQUFRLEVBQUUsTUFBVyxFQUFFLFFBQWtDO0lBQ3BGLE9BQU8sR0FBRyxDQUFDLE1BQU0sRUFBRSxVQUFBLENBQUMsSUFBSSxPQUFBLFFBQVEsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxFQUExQixDQUEwQixDQUFDLENBQUM7QUFDeEQsQ0FBQztBQUZELGtDQUVDO0FBRUQ7Ozs7R0FJRztBQUNILHlCQUFtQyxDQUFJLEVBQUUsQ0FBSTtJQUN6QyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDbkIsQ0FBQztBQUZELDBDQUVDO0FBRUQsMENBQTBDO0FBQzFDLHdCQUFrQyxDQUFNLEVBQUUsQ0FBTSxFQUFFLFFBQWtDO0lBQ2hGLElBQUksQ0FBQyxLQUFLLENBQUM7UUFBRSxPQUFPLElBQUksQ0FBQztJQUN6QixJQUFJLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLElBQUk7UUFBRSxPQUFPLEtBQUssQ0FBQztJQUN6QyxJQUFJLENBQUMsQ0FBQyxNQUFNLElBQUksQ0FBQyxDQUFDLE1BQU07UUFBRSxPQUFPLEtBQUssQ0FBQztJQUV2QyxRQUFRLEdBQUcsUUFBUSxJQUFJLENBQUMsVUFBQyxDQUFDLEVBQUUsQ0FBQyxJQUFLLE9BQUEsQ0FBQyxLQUFLLENBQUMsRUFBUCxDQUFPLENBQUMsQ0FBQztJQUMzQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsQ0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUMvQixJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFBRSxPQUFPLEtBQUssQ0FBQztLQUMzQztJQUNELE9BQU8sSUFBSSxDQUFDO0FBQ2hCLENBQUM7QUFWRCx3Q0FVQztBQUVEOztHQUVHO0FBQ0gsbUJBQTZCLENBQU0sRUFBRSxDQUFNLEVBQUUsUUFBa0M7O1FBQzNFLEtBQW9CLElBQUEsTUFBQSxTQUFBLENBQUMsQ0FBQSxvQkFBQTtZQUFoQixJQUFNLEtBQUssY0FBQTtZQUNaLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxRQUFRLENBQUM7Z0JBQUUsT0FBTyxLQUFLLENBQUM7U0FDbkQ7Ozs7Ozs7Ozs7UUFDRCxLQUFvQixJQUFBLE1BQUEsU0FBQSxDQUFDLENBQUEsb0JBQUE7WUFBaEIsSUFBTSxLQUFLLGNBQUE7WUFDWixJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsUUFBUSxDQUFDO2dCQUFFLE9BQU8sS0FBSyxDQUFDO1NBQ25EOzs7Ozs7Ozs7SUFDRCxPQUFPLElBQUksQ0FBQzs7QUFDaEIsQ0FBQztBQVJELDhCQVFDO0FBRUQsbUNBQW1DLENBQU07SUFDckMsSUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLENBQUM7SUFDdEIsSUFBTSxhQUFhLEdBQUcsSUFBSSxJQUFJLFFBQVEsSUFBSSxJQUFJLElBQUksU0FBUyxJQUFJLElBQUksSUFBSSxRQUFRLElBQUksSUFBSSxJQUFJLFFBQVEsSUFBSSxJQUFJLElBQUksVUFBVSxDQUFDO0lBQzFILE9BQU8sYUFBYSxJQUFJLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxZQUFZLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDNUQsQ0FBQztBQUVELGlEQUFpRDtBQUNqRCx1QkFBaUMsQ0FBSSxFQUFFLENBQUksRUFBRSxRQUFvRDtJQUM3RixJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3hCLE9BQU8sS0FBSyxDQUFDO0lBRWpCLElBQUkseUJBQXlCLENBQUMsQ0FBQyxDQUFDLElBQUkseUJBQXlCLENBQUMsQ0FBQyxDQUFDLEVBQUU7UUFDOUQsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO0tBQ2xCO0lBQ0QsSUFBSSxDQUFDLFlBQVksSUFBSSxJQUFJLENBQUMsWUFBWSxJQUFJLEVBQUU7UUFDeEMsSUFBSSxDQUFDLFlBQVksSUFBSSxJQUFJLENBQUMsWUFBWSxJQUFJLEVBQUU7WUFDeEMsT0FBTyxDQUFDLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxDQUFDLE9BQU8sRUFBRSxDQUFDO1NBQ3JDOztZQUFNLE9BQU8sS0FBSyxDQUFDO0tBQ3ZCO0lBRUQsSUFBSSxDQUFDLEtBQUssQ0FBQztRQUFFLE9BQU8sSUFBSSxDQUFDO0lBQ3pCLElBQUksQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSTtRQUFFLE9BQU8sS0FBSyxDQUFDO0lBRXpDLElBQUksVUFBVSxDQUFDLENBQUMsQ0FBQyxJQUFJLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNoQyxPQUFPLGNBQWMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0tBQzNEO0lBRUQsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFZLEVBQVosQ0FBWSxDQUFDLENBQUM7SUFDcEQsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFZLEVBQVosQ0FBWSxDQUFDLENBQUM7SUFFcEQsSUFBSSxLQUFLLENBQUMsTUFBTSxJQUFJLEtBQUssQ0FBQyxNQUFNO1FBQUUsT0FBTyxLQUFLLENBQUM7SUFDL0MsT0FBTyxjQUFjLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBSixDQUFJLENBQUMsRUFBRSxLQUFLLENBQUMsR0FBRyxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFKLENBQUksQ0FBQyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0FBQ2hGLENBQUM7QUF6QkQsc0NBeUJDO0FBV0Q7Ozs7O0dBS0c7QUFDSCxxQkFBK0IsQ0FBSSxFQUFFLENBQUksRUFBRSxRQUFvRDtJQUMzRixJQUFNLEtBQUssR0FBRyxRQUFRLElBQUksZUFBZSxDQUFDO0lBQzFDLElBQU0sS0FBSyxHQUNQLFdBQUksQ0FDQSxLQUFLLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQ3JDLFVBQUEsSUFBSSxJQUFJLE9BQUEsSUFBSSxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsVUFBVSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLEVBQXJFLENBQXFFLENBQUMsRUFBcEYsQ0FBb0YsRUFDNUYsVUFBQSxJQUFJLElBQUksT0FBQSxJQUFJLENBQUMsTUFBTSxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUMsVUFBVSxDQUFDLEVBQTdCLENBQTZCLENBQUMsRUFBL0MsQ0FBK0MsRUFFdkQsVUFBQSxJQUFJLElBQUksT0FBQSxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxDQUFDLEdBQUcsRUFBTCxDQUFLLENBQUMsRUFBcEIsQ0FBb0IsRUFFNUIsVUFBQSxJQUFJLElBQUksT0FBQSxVQUFVLENBQUMsSUFBSSxFQUFFLFVBQUEsSUFBSSxJQUFJLE9BQUEsSUFBSSxFQUFKLENBQUksRUFBRSxVQUFBLElBQUksSUFBSSxPQUFBLElBQUksRUFBSixDQUFJLENBQUMsRUFBNUMsQ0FBNEMsQ0FDdkQsQ0FBQztJQUdOLE9BQU8sS0FBWSxDQUFDO0FBQ3hCLENBQUM7QUFmRCxrQ0FlQztBQUVELHFHQUFxRztBQUNyRyxpQkFBMkIsR0FBK0I7SUFDdEQsSUFBSSxHQUFHLFlBQVksS0FBSyxFQUFFO1FBQ3RCLE9BQU8sR0FBRyxDQUFDO0tBQ2Q7SUFFRCxJQUFNLFdBQVcsR0FBRyxVQUFDLENBQU0sSUFBMEIsT0FBQSxDQUFDLENBQUMsTUFBTSxLQUFLLFNBQVMsRUFBdEIsQ0FBc0IsQ0FBQztJQUM1RSxJQUFNLEdBQUcsR0FBUSxFQUFFLENBQUM7SUFDcEIsSUFBSSxXQUFXLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDbEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDakMsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUNwQjtLQUNKO1NBQU07O1lBQ0gsS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO2dCQUFkLElBQU0sQ0FBQyxnQkFBQTtnQkFDUixHQUFHLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO2FBQ2Y7Ozs7Ozs7OztLQUNKO0lBQ0QsT0FBTyxHQUFHLENBQUM7O0FBQ2YsQ0FBQztBQWpCRCwwQkFpQkM7QUFFRCwrRkFBK0Y7QUFDL0Ysb0JBQTJCLEdBQVE7SUFDL0IsT0FBTyxXQUFXLENBQUMsR0FBRyxDQUFDLElBQUksb0JBQW9CLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDekQsQ0FBQztBQUZELGdDQUVDO0FBRUQsb0RBQW9EO0FBQ3BELHFCQUE0QixDQUFNO0lBQzlCLE9BQU8sQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLENBQUMsTUFBTSxLQUFLLFNBQVMsQ0FBQztBQUMvQyxDQUFDO0FBRkQsa0NBRUM7QUFFRCxJQUFNLG9CQUFvQixHQUFHLFVBQUMsUUFBYSxJQUFnQyxPQUFBLFFBQVEsS0FBSyxJQUFJLElBQUksTUFBTSxDQUFDLFFBQVEsSUFBSSxNQUFNLENBQUMsUUFBUSxDQUFDLEVBQXhELENBQXdELENBQUM7QUFFcEksb0JBQThCLENBQUksRUFBRSxDQUFJO0lBQ3BDLElBQU0sSUFBSSxHQUFHLFVBQUMsQ0FBQyxFQUFFLENBQUMsSUFBSyxPQUFBLGFBQWEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLElBQUksQ0FBQyxFQUF6QixDQUF5QixDQUFDO0lBQ2pELE9BQU8sSUFBSSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztBQUN0QixDQUFDO0FBSEQsZ0NBR0M7QUFFRCxzQ0FBc0M7QUFDdEMsZUFBaUMsR0FBUSxFQUFFLEdBQXlCLEVBQUUsS0FBMkI7SUFDN0YsSUFBTSxHQUFHLEdBQWdDLEVBQUUsQ0FBQTs7UUFDM0MsS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO1lBQWQsSUFBTSxDQUFDLGdCQUFBO1lBQ1IsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUFBOzs7Ozs7Ozs7SUFFM0IsT0FBTyxHQUFHLENBQUM7O0FBQ2YsQ0FBQztBQU5ELHNCQU1DO0FBR0QseUNBQXlDO0FBQ3pDLGlCQUEyQixHQUFVO0lBQ2pDLElBQU0sR0FBRyxHQUFRLEVBQUUsQ0FBQzs7UUFDcEIsS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO1lBQWQsSUFBTSxDQUFDLGdCQUFBO1lBQ1IsR0FBRyxDQUFDLElBQUksT0FBUixHQUFHLFdBQVMsQ0FBQyxHQUFFO1NBQUE7Ozs7Ozs7OztJQUNuQixPQUFPLEdBQUcsQ0FBQzs7QUFDZixDQUFDO0FBTEQsMEJBS0M7QUFHRDs7R0FFRztBQUNILGVBQXlCLEdBQVEsRUFBRSxJQUEyQjs7UUFDMUQsS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO1lBQWQsSUFBTSxDQUFDLGdCQUFBO1lBQ1IsSUFBSSxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsQ0FBQyxDQUFDO2dCQUNoQixPQUFPLENBQUMsQ0FBQztTQUNoQjs7Ozs7Ozs7O0lBQ0QsT0FBTyxTQUFTLENBQUM7O0FBQ3JCLENBQUM7QUFORCxzQkFNQztBQUVEOztHQUVHO0FBQ0gsZ0JBQTBCLEdBQVEsRUFBRSxJQUEyQjtJQUMzRCxJQUFJLFNBQVMsR0FBa0IsU0FBUyxDQUFDO0lBQ3pDLElBQUksS0FBSyxHQUFZLEtBQUssQ0FBQzs7UUFDM0IsS0FBZ0IsSUFBQSxRQUFBLFNBQUEsR0FBRyxDQUFBLHdCQUFBO1lBQWQsSUFBTSxDQUFDLGdCQUFBO1lBQ1IsSUFBTSxJQUFJLEdBQUcsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBRTlCLElBQUksSUFBSSxFQUFFO2dCQUNOLElBQUksS0FBSyxFQUFFO29CQUNQLFlBQVk7b0JBQ1osT0FBTyxTQUFTLENBQUM7aUJBQ3BCO3FCQUFNO29CQUNILFNBQVMsR0FBRyxDQUFDLENBQUM7b0JBQ2QsS0FBSyxHQUFHLElBQUksQ0FBQztpQkFDaEI7YUFDSjtTQUNKOzs7Ozs7Ozs7SUFDRCxPQUFPLFNBQVMsQ0FBQzs7QUFDckIsQ0FBQztBQWpCRCx3QkFpQkM7QUFFRCwrQ0FBK0M7QUFDL0MsY0FBd0IsR0FBUTtJQUM1QixPQUFPLEdBQUcsQ0FBQyxHQUFHLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO0FBQy9CLENBQUM7QUFGRCxvQkFFQztBQUlEOzs7R0FHRztBQUNILGlCQUFpQyxHQUFRLEVBQUUsT0FBMEIsRUFBRSxRQUF3QztJQUMzRyxJQUFNLEdBQUcsR0FBd0IsRUFBRSxDQUFDO0lBQ3BDLElBQU0sZUFBZSxHQUFHLFFBQVEsSUFBSSxhQUFhLENBQUM7NEJBQ3ZDLENBQUM7UUFDUixJQUFNLEdBQUcsR0FBRyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDdkIsSUFBTSxTQUFTLEdBQUcsS0FBSyxDQUFDLEdBQUcsRUFBRSxVQUFBLENBQUMsSUFBSSxPQUFBLGVBQWUsQ0FBQyxDQUFDLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxFQUEzQixDQUEyQixDQUFDLENBQUM7UUFDL0QsSUFBSSxTQUFTLEtBQUssU0FBUyxFQUFFO1lBQ3pCLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQztTQUN0QzthQUFNO1lBQ0gsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDM0I7SUFDTCxDQUFDOztRQVJELEtBQWdCLElBQUEsUUFBQSxTQUFBLEdBQUcsQ0FBQSx3QkFBQTtZQUFkLElBQU0sQ0FBQyxnQkFBQTtvQkFBRCxDQUFDO1NBUVg7Ozs7Ozs7OztJQUNELE9BQU8sR0FBRyxDQUFDOztBQUNmLENBQUM7QUFiRCwwQkFhQztBQWdCRCxvQkFBa0MsR0FBTSxFQUFFLFFBQWtEO0lBQ3hGLElBQU0sZUFBZSxHQUFHLENBQUMsVUFBQyxHQUFZLEVBQUUsS0FBaUIsSUFBSyxPQUFBLENBQUMsRUFBRSxHQUFHLEtBQUEsRUFBRSxLQUFLLE9BQUEsRUFBRSxDQUFDLEVBQWhCLENBQWdCLENBQUMsQ0FBQztJQUNoRixJQUFNLGlCQUFpQixHQUFHLFFBQVEsSUFBSSxlQUFlLENBQUM7SUFDdEQsSUFBSSxRQUFRLEVBQUU7UUFDVixPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLFVBQUEsR0FBRyxJQUFJLE9BQUEsUUFBUSxDQUFDLEdBQWMsRUFBRSxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBbEMsQ0FBa0MsQ0FBQyxDQUFDO0tBQzFFO1NBQU07UUFDSCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLFVBQUEsR0FBRyxJQUFJLE9BQUEsR0FBYyxFQUFkLENBQWMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFBLEdBQUcsSUFBSSxPQUFBLGVBQWUsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEVBQTlCLENBQThCLENBQUMsQ0FBQztLQUNqRztBQUNMLENBQUM7QUFSRCxnQ0FRQztBQWFELG9CQUFzQyxLQUFVLEVBQUUsV0FBaUMsRUFBRSxhQUFtQztJQUNwSCxJQUFNLGtCQUFrQixHQUFHLFVBQUMsSUFBUyxJQUFLLE9BQUEsSUFBSSxDQUFDLEdBQUcsRUFBUixDQUFRLENBQUM7SUFDbkQsSUFBTSxvQkFBb0IsR0FBRyxVQUFDLElBQVMsSUFBSyxPQUFBLElBQUksQ0FBQyxLQUFLLEVBQVYsQ0FBVSxDQUFDO0lBRXZELElBQU0sb0JBQW9CLEdBQUcsV0FBVyxJQUFJLGtCQUFrQixDQUFDO0lBQy9ELElBQU0sc0JBQXNCLEdBQUcsYUFBYSxJQUFJLG9CQUFvQixDQUFDO0lBQ3JFLElBQU0sR0FBRyxHQUFHLEVBQUUsQ0FBQzs7UUFDZixLQUFnQixJQUFBLFVBQUEsU0FBQSxLQUFLLENBQUEsNEJBQUE7WUFBaEIsSUFBTSxDQUFDLGtCQUFBO1lBQ1IsSUFBTSxHQUFHLEdBQUcsb0JBQW9CLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDcEMsSUFBTSxLQUFLLEdBQUcsc0JBQXNCLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDeEMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUssQ0FBQztTQUNwQjs7Ozs7Ozs7O0lBQ0QsT0FBTyxHQUFHLENBQUM7O0FBQ2YsQ0FBQztBQWJELGdDQWFDO0FBQ0Q7Ozs7R0FJRztBQUNILG1CQUFtQyxHQUFNLEVBQUUsR0FBcUQ7SUFDNUYsSUFBTSxHQUFHLEdBQUcsRUFBRSxDQUFDO0lBQ2YsS0FBSyxJQUFNLEdBQUcsSUFBSSxHQUFHLEVBQUU7UUFDbkIsSUFBTSxLQUFLLEdBQUcsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZCLEdBQUcsQ0FBQyxHQUFhLENBQUMsR0FBRyxHQUFHLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0tBQ3hDO0lBQ0QsT0FBTyxHQUErQixDQUFDO0FBQzNDLENBQUM7QUFQRCw4QkFPQztBQUVEOzs7O0dBSUc7QUFDSCxzQkFBK0QsR0FBTSxFQUFFLElBQWtEO0lBQ3JILElBQU0sR0FBRyxHQUFHLEVBQUUsQ0FBQztJQUNmLEtBQUssSUFBTSxHQUFHLElBQUksR0FBRyxFQUFFO1FBQ25CLElBQU0sS0FBSyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUN2QixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLEVBQUU7WUFDbEIsR0FBRyxDQUFDLEdBQWEsQ0FBQyxHQUFHLEtBQUssQ0FBQztTQUM5QjtLQUNKO0lBQ0QsT0FBTyxHQUFRLENBQUM7QUFDcEIsQ0FBQztBQVRELG9DQVNDO0FBRUQ7Ozs7R0FJRztBQUNILGNBQXdCLEdBQU0sRUFBRSxJQUFpQjtJQUM3QyxPQUFPLFlBQVksQ0FBQyxHQUFHLEVBQUUsVUFBQyxLQUFLLEVBQUUsR0FBRyxJQUFLLE9BQUEsQ0FBQyxRQUFRLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxFQUFwQixDQUFvQixDQUFDLENBQUM7QUFDbkUsQ0FBQztBQUZELG9CQUVDO0FBR0QsOERBQThEO0FBQzlELHVCQUFpQyxHQUFNO0lBQ25DLE9BQU8sWUFBWSxDQUFDLEdBQUcsRUFBRSxVQUFBLEtBQUssSUFBSSxPQUFBLEtBQUssS0FBSyxTQUFTLEVBQW5CLENBQW1CLENBQUMsQ0FBQztBQUMzRCxDQUFDO0FBRkQsc0NBRUM7QUFFRCwrS0FBK0s7QUFDL0ssY0FBeUQsR0FBTTtJQUFFLGVBQWdCO1NBQWhCLFVBQWdCLEVBQWhCLHFCQUFnQixFQUFoQixJQUFnQjtRQUFoQiw4QkFBZ0I7O0lBQzdFLElBQUksR0FBRyxHQUFlLEVBQUUsQ0FBQzs7UUFDekIsS0FBa0IsSUFBQSxVQUFBLFNBQUEsS0FBSyxDQUFBLDRCQUFBO1lBQWxCLElBQU0sR0FBRyxrQkFBQTtZQUNWLElBQUksR0FBRyxJQUFJLEdBQUcsRUFBRTtnQkFDWixHQUFHLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2FBQ3ZCO1NBQ0o7Ozs7Ozs7OztJQUNELE9BQU8sR0FBVSxDQUFDOztBQUN0QixDQUFDO0FBUkQsb0JBUUM7QUFFRCwrR0FBK0c7QUFDL0csbUJBQTZCLEtBQVUsRUFBRSxDQUFTLEVBQUUsQ0FBUztJQUN6RCxJQUFNLE1BQU0sR0FBRyxVQUFDLENBQVMsSUFBSyxPQUFBLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQTFCLENBQTBCLENBQUM7SUFDekQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFDeEIsTUFBTSxJQUFJLEtBQUssQ0FBQyx1QkFBdUIsQ0FBQyxDQUFDO0lBRTdDLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQyxVQUFDLENBQUMsRUFBRSxDQUFDLEVBQUUsR0FBRztRQUN2QixPQUFBLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2IsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2IsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUZkLENBRWMsQ0FBQyxDQUFDO0FBQ3hCLENBQUM7QUFURCw4QkFTQztBQUVEOztFQUVFO0FBQ0Ysa0JBQTRCLEtBQVUsRUFBRSxXQUFtQixFQUFFLFNBQWlCO0lBQzFFLElBQU0sTUFBTSxHQUFHLFVBQUMsQ0FBUyxJQUFLLE9BQUEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsS0FBSyxDQUFDLE1BQU0sRUFBMUIsQ0FBMEIsQ0FBQztJQUN6RCxJQUFJLENBQUMsTUFBTSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQztRQUMxQyxNQUFNLElBQUksS0FBSyxDQUFDLHVCQUF1QixDQUFDLENBQUM7SUFFN0MseURBQXlEO0lBQ3pELElBQUksV0FBVyxJQUFJLFNBQVM7UUFBRSxPQUFPLEtBQUssQ0FBQztJQUUzQyw2Q0FBNkM7SUFDN0MsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLEdBQUcsV0FBVyxDQUFhLENBQUM7SUFDM0QsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDN0MsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDN0MsT0FBTyxLQUFLLENBQUMsR0FBRyxDQUFDLFVBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxHQUFHO1FBQ3ZCLE9BQUEsQ0FBQyxDQUFDLEdBQUcsR0FBRyxJQUFJLENBQUMsR0FBRyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDdEIsQ0FBQyxDQUFDLElBQUksU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDO2dCQUNqQyxHQUFHLENBQUMsQ0FBQyxHQUFHLEdBQUcsQ0FBQztJQUZwQixDQUVvQixDQUFDLENBQUM7QUFFOUIsQ0FBQztBQWpCRCw0QkFpQkM7QUFFRCxvSkFBb0o7QUFDcEosb0JBQThCLEtBQVUsRUFBRSxLQUFhLEVBQUUsU0FBd0I7SUFDN0UsSUFBSSxDQUFDLEtBQUssSUFBSSxDQUFDLElBQUksU0FBUyxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLEtBQUssQ0FBQyxNQUFNLEdBQUcsQ0FBQyxJQUFJLFNBQVMsSUFBSSxNQUFNLENBQUMsRUFBRTtRQUN6RixPQUFPLEtBQUssQ0FBQztLQUNoQjtTQUFNO1FBQ0gsT0FBTyxRQUFRLENBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEdBQUcsQ0FBQyxTQUFTLElBQUksSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ3hFO0FBQ0wsQ0FBQztBQU5ELGdDQU1DO0FBTUQsdUJBQThCLEdBQVE7SUFDbEMsSUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUM5QixJQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQUEsR0FBRyxJQUFJLE9BQUEsR0FBRyxDQUFDLEdBQUcsQ0FBQyxFQUFSLENBQVEsQ0FBQyxDQUFDO0lBQ3pDLElBQU0sR0FBRyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDaEMsSUFBTSxHQUFHLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxVQUFBLEdBQUcsSUFBSSxPQUFBLEdBQUcsQ0FBQyxHQUFHLENBQUMsVUFBQyxLQUFLLEVBQUUsS0FBSyxJQUFLLE9BQUEsQ0FBQyxFQUFFLEdBQUcsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxDQUFDLEVBQXBDLENBQW9DLENBQUMsRUFBL0QsQ0FBK0QsQ0FBQyxDQUFDLElBQUksQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBYixDQUFhLENBQUMsQ0FBQztJQUN0SCxPQUFPLEdBQUcsQ0FBQztBQUNmLENBQUM7QUFORCxzQ0FNQztBQUVELHNMQUFzTDtBQUN0TCxzQkFBK0UsR0FBTTtJQUdqRixJQUFNLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBZ0IsQ0FBQztJQUs1QyxDQUFDO0lBRUYsSUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxVQUFBLEdBQUcsSUFBSSxPQUFBLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDO1FBQzlDLEtBQUssRUFBRSxDQUFDO1FBQ1IsR0FBRyxFQUFFLEdBQUc7S0FDWCxDQUFDLEVBSCtDLENBRy9DLENBQUMsRUFINEIsQ0FHNUIsQ0FBQyxDQUFDO0lBSUwsSUFBTSxPQUFPLEdBQUcsRUFBRSxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsVUFBVSxDQUFDLENBQUMsQ0FBQyxFQUFiLENBQWEsQ0FBRSxDQUFFO0lBQzlFLE9BQU8sT0FBNkIsQ0FBQztBQUN6QyxDQUFDO0FBbkJELG9DQW1CQztBQUdEOztHQUVHO0FBQ0gsa0JBQW1ELEdBQW1CLEVBQUUsT0FBK0I7SUFDbkcsSUFBTSxHQUFHLEdBQUcsV0FBSSxDQUNaLE9BQU8sRUFDUCxVQUFBLEdBQUcsSUFBSSxPQUFBLFlBQVksQ0FBQyxHQUFHLEVBQUUsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLENBQUMsQ0FBQyxFQUFILENBQUcsQ0FBQyxFQUEzQixDQUEyQixFQUNsQyxVQUFBLEdBQUcsSUFBSSxPQUFBLFNBQVMsQ0FBd0MsR0FBVSxFQUFFLFVBQUMsS0FBSyxFQUFFLEdBQVksSUFBSyxPQUFBLEdBQUcsQ0FBQyxJQUFJLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLENBQUMsR0FBRyxDQUFDLEVBQU4sQ0FBTSxDQUFRLEVBQTVCLENBQTRCLENBQUMsRUFBbkgsQ0FBbUgsQ0FDN0gsQ0FBQztJQUVGLE9BQU8sR0FBVSxDQUFDO0FBQ3RCLENBQUM7QUFSRCw0QkFRQztBQUVEOztFQUVFO0FBQ0YsZ0JBQTBCLEdBQVEsRUFBRSxRQUFrQztJQUNsRSxPQUFPLE9BQU8sQ0FBTyxHQUFHLEVBQUUsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLEVBQUQsQ0FBQyxFQUFFLGVBQWUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsQ0FBQyxHQUFHLEVBQUwsQ0FBSyxDQUFDLENBQUE7QUFDdEUsQ0FBQztBQUZELHdCQUVDO0FBRUQ7O0dBRUc7QUFDSDtJQUF5QixhQUFhO1NBQWIsVUFBYSxFQUFiLHFCQUFhLEVBQWIsSUFBYTtRQUFiLHdCQUFhOztJQUNsQyxPQUFPLE1BQU0sQ0FBQyxNQUFNLHdCQUFJLEdBQUcsR0FBRSxDQUFDO0FBQ2xDLENBQUM7QUFGRCxzQkFFQztBQUVEOzs7OztHQUtHO0FBQ0gsa0JBQW9DLENBQU8sRUFBRSxDQUFPLEVBQUUsTUFBNEIsRUFBRSxRQUFrQztJQUNsSCxJQUFNLFdBQVcsR0FBRyxRQUFRLElBQUksVUFBVSxDQUFDO0lBQzNDLElBQUksTUFBTSxHQUFnQixFQUFFLENBQUM7SUFFN0IsK0JBQStCO0lBQy9CLElBQU0sS0FBSyxHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUM7O1FBRTVCLDRDQUE0QztRQUM1QyxLQUFvQixJQUFBLE1BQUEsU0FBQSxDQUFDLENBQUEsb0JBQUE7WUFBaEIsSUFBTSxLQUFLLGNBQUE7WUFDWixJQUFNLElBQUksR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDM0IsSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLEVBQUUsSUFBSSxFQUFFLFdBQVcsQ0FBQyxFQUFFO2dCQUNyQyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO2FBQ3RCO1NBQ0o7Ozs7Ozs7OztJQUVELDBCQUEwQjtJQUMxQixNQUFNLENBQUMsSUFBSSxPQUFYLE1BQU0sV0FBUyxDQUFDLEdBQUU7SUFDbEIsT0FBTyxNQUFNLENBQUM7O0FBQ2xCLENBQUM7QUFsQkQsNEJBa0JDO0FBRUQsNklBQTZJO0FBQzdJLGlCQUFnQyxDQUFPLEVBQUUsQ0FBTyxFQUFFLFFBQW9DO0lBQ2xGLElBQU0sV0FBVyxHQUFHLFFBQVEsSUFBSSxDQUFDLFVBQUMsQ0FBSyxFQUFFLENBQUssSUFBSyxPQUFBLFFBQVEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQWQsQ0FBYyxDQUFDLENBQUM7SUFDbkUsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLFVBQUEsS0FBSyxJQUFJLE9BQUEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxXQUFXLENBQUMsRUFBaEMsQ0FBZ0MsQ0FBQyxDQUFDO0FBQy9ELENBQUM7QUFIRCwwQkFHQztBQUVEOzs7R0FHRztBQUNILHFCQUFxQyxLQUFVLEVBQUUsSUFBWSxFQUFFLFdBQThCLEVBQUUsUUFBd0M7SUFDbkksSUFBTSxXQUFXLEdBQUcsUUFBUSxJQUFJLGFBQWEsQ0FBQztJQUM5QyxPQUFPLE9BQU8sQ0FBQyxLQUFLLEVBQUUsSUFBSSxFQUFFLFVBQUMsQ0FBQyxFQUFFLENBQUMsSUFBSyxPQUFBLFdBQVcsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQTlCLENBQThCLENBQUMsQ0FBQztBQUMxRSxDQUFDO0FBSEQsa0NBR0M7QUFFRCw4Q0FBOEM7QUFDOUM7SUFBMEIsYUFBYTtTQUFiLFVBQWEsRUFBYixxQkFBYSxFQUFiLElBQWE7UUFBYix3QkFBYTs7SUFDbkMsT0FBTyxHQUFHLENBQUMsTUFBTSxDQUFDLFVBQUMsSUFBSSxFQUFFLElBQUksSUFBSyxnQkFBSSxJQUFJLEVBQUssSUFBSSxHQUFqQixDQUFrQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBQzlELENBQUM7QUFGRCx3QkFFQztBQUVELDJGQUEyRjtBQUMzRixrQkFBNEIsR0FBUSxFQUFFLFNBQStCLEVBQUUsU0FBa0I7SUFDckYsT0FBTyxTQUFTLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQztBQUNuRCxDQUFDO0FBRkQsNEJBRUM7QUFFRDs7Ozs7O0dBTUc7QUFDSCxpQkFBaUMsSUFBWSxFQUFFLE1BQVcsRUFBRSxXQUE4QixFQUFFLFdBQTJDO0lBQ25JLElBQU0sb0JBQW9CLEdBQUcsV0FBVyxJQUFJLGFBQWEsQ0FBQztJQUMxRCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBQSxHQUFHLElBQUksT0FBQSxLQUFLLENBQUMsTUFBTSxFQUFFLFVBQUEsS0FBSyxJQUFJLE9BQUEsYUFBYSxDQUFDLEdBQUcsRUFBRSxXQUFXLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBdEMsQ0FBc0MsQ0FBRSxFQUEvRCxDQUErRCxDQUFDLENBQUM7QUFDNUYsQ0FBQztBQUhELDBCQUdDO0FBRUQ7O0dBRUc7QUFDSCxtQkFBNkIsQ0FBTSxFQUFFLENBQU0sRUFBRSxRQUFrQztJQUMzRSxPQUFPLGFBQWEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxFQUFELENBQUMsRUFBRSxRQUFRLElBQUksZUFBZSxDQUFDLENBQUM7QUFDcEUsQ0FBQztBQUZELDhCQUVDO0FBRUQ7O0dBRUc7QUFDSCxrQkFBNEIsR0FBUSxFQUFFLE1BQVcsRUFBRSxRQUFrQztJQUNqRiw0RUFBNEU7SUFDNUUsT0FBTyxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUUsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLFFBQVEsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFDLEVBQWpCLENBQWlCLENBQUMsQ0FBQztBQUNoRCxDQUFDO0FBSEQsNEJBR0M7QUFFRDs7O0dBR0c7QUFDSCx1QkFBdUMsS0FBVSxFQUFFLElBQVksRUFBRSxXQUE4QixFQUFFLFFBQXdDO0lBQ3JJLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFBLElBQUksSUFBSSxPQUFBLFFBQVEsQ0FBQyxJQUFJLEVBQUUsV0FBVyxDQUFDLElBQUksQ0FBQyxFQUFFLFFBQVEsSUFBSSxhQUFhLENBQUMsRUFBNUQsQ0FBNEQsQ0FBQyxDQUFDO0FBQzlGLENBQUM7QUFGRCxzQ0FFQztBQUVELGtDQUFrQztBQUNsQyxlQUFzQixLQUFhLEVBQUUsS0FBYSxFQUFFLElBQWE7SUFDN0QsSUFBSSxHQUFHLEdBQWEsRUFBRSxDQUFDO0lBQ3ZCLElBQUksR0FBRyxJQUFJLElBQUksQ0FBQyxDQUFDO0lBQ2pCLElBQU0sR0FBRyxHQUFHLEtBQUssR0FBRyxLQUFLLEdBQUcsSUFBSSxDQUFDO0lBRWpDLEtBQUssSUFBSSxDQUFDLEdBQUcsS0FBSyxFQUFFLENBQUMsR0FBRyxHQUFHLEVBQUUsQ0FBQyxJQUFJLElBQUksRUFBRTtRQUNwQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2Y7SUFDRCxPQUFPLEdBQUcsQ0FBQztBQUNmLENBQUM7QUFURCxzQkFTQztBQUVEOztHQUVHO0FBQ0gsY0FBd0IsR0FBUSxFQUFFLElBQU87SUFDckMsZ0JBQVcsR0FBRyxHQUFFLElBQUksR0FBRTtBQUMxQixDQUFDO0FBRkQsb0JBRUM7QUFFRDs7R0FFRztBQUNILGlCQUEyQixHQUFRLEVBQUUsU0FBOEMsRUFBRSxRQUFXO0lBQzVGLE9BQU8sR0FBRyxDQUFDLEdBQUcsQ0FBQyxVQUFDLENBQUMsRUFBRSxDQUFDLElBQUssT0FBQSxTQUFTLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBOUIsQ0FBOEIsQ0FBQyxDQUFDO0FBQzdELENBQUM7QUFGRCwwQkFFQztBQUVELHFDQUFxQztBQUNyQyxnQkFBMEIsR0FBUSxFQUFFLElBQU87SUFDdkMsT0FBTyxHQUFHLENBQUMsTUFBTSxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxJQUFJLElBQUksRUFBVCxDQUFTLENBQUMsQ0FBQztBQUN0QyxDQUFDO0FBRkQsd0JBRUM7QUFFRDs7OztHQUlHO0FBQ0g7SUFBb0MsbUJBQXdDO1NBQXhDLFVBQXdDLEVBQXhDLHFCQUF3QyxFQUF4QyxJQUF3QztRQUF4Qyw4QkFBd0M7O0lBQ3hFLE9BQU8sVUFBQyxDQUFJLEVBQUUsQ0FBSTs7WUFDZCxLQUFtQixJQUFBLGNBQUEsU0FBQSxTQUFTLENBQUEsb0NBQUE7Z0JBQXZCLElBQU0sSUFBSSxzQkFBQTtnQkFDWCxJQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO2dCQUMxQixJQUFJLE1BQU0sSUFBSSxDQUFDO29CQUFFLE9BQU8sTUFBTSxDQUFDO2FBQ2xDOzs7Ozs7Ozs7UUFDRCxPQUFPLENBQUMsQ0FBQzs7SUFDYixDQUFDLENBQUM7QUFDTixDQUFDO0FBUkQsNENBUUM7QUFFRCw2RkFBNkY7QUFDN0YseUJBQW1DLENBQUksRUFBRSxDQUFJO0lBQ3pDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUNULE9BQU8sQ0FBQyxDQUFDO0tBQ1o7U0FBTSxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksQ0FBQyxLQUFLLFNBQVMsRUFBRTtRQUN0QyxPQUFPLENBQUMsQ0FBQztLQUNaO1NBQU0sSUFBSSxDQUFDLEtBQUssU0FBUyxJQUFJLENBQUMsS0FBSyxJQUFJLEVBQUU7UUFDdEMsT0FBTyxDQUFDLENBQUMsQ0FBQztLQUNiOztRQUNHLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBQzFDLENBQUM7QUFURCwwQ0FTQztBQUlEOztHQUVHO0FBQ0gsY0FBd0IsR0FBUTtJQUFFLG1CQUFxQztTQUFyQyxVQUFxQyxFQUFyQyxxQkFBcUMsRUFBckMsSUFBcUM7UUFBckMsa0NBQXFDOztJQUNuRSxTQUFTLEdBQUcsU0FBUyxDQUFDLE1BQU0sSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsZUFBZSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQztJQUVsRSxJQUFNLGFBQWEsR0FBRyxVQUFDLElBQXlCLElBQUssT0FBQSxVQUFDLENBQUssRUFBRSxDQUFLLElBQUssT0FBQSxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLEVBQXRCLENBQXNCLEVBQXhDLENBQXdDLENBQUM7SUFDOUYsK0JBQStCO0lBQy9CLElBQU0sWUFBWSxZQUNYLFNBQVMsQ0FBQyxHQUFHLENBQUMsYUFBYSxDQUFDO1FBQy9CLFVBQUMsQ0FBQyxFQUFFLENBQUMsSUFBSyxPQUFBLENBQUMsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBakIsQ0FBaUI7TUFDOUIsQ0FBQztJQUNGLElBQU0saUJBQWlCLEdBQUcsZ0JBQWdCLHdCQUFJLFlBQVksRUFBQyxDQUFDO0lBRTVELElBQU0sSUFBSSxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDLEVBQUUsQ0FBQyxJQUFLLE9BQUEsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQXhCLENBQXdCLENBQUMsQ0FBQztJQUN6RCxJQUFJLENBQUMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLENBQUM7SUFFN0IsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsQ0FBQyxLQUFLLEVBQVAsQ0FBTyxDQUFDLENBQUM7SUFDbkMsT0FBTyxHQUFHLENBQUM7QUFDZixDQUFDO0FBaEJELG9CQWdCQztBQUVEOztHQUVHO0FBQ0gsaUJBQTJCLEdBQVE7SUFBRSxzQkFBa0M7U0FBbEMsVUFBa0MsRUFBbEMscUJBQWtDLEVBQWxDLElBQWtDO1FBQWxDLHFDQUFrQzs7SUFDbkUsSUFBTSxTQUFTLEdBQUcsWUFBWSxDQUFDLEdBQUcsQ0FBQyxVQUFBLFFBQVEsSUFBSSxPQUFBLFVBQUMsQ0FBSSxFQUFFLENBQUksSUFBSyxPQUFBLENBQUMsZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBMUMsQ0FBMEMsRUFBMUQsQ0FBMEQsQ0FBQyxDQUFDO0lBQzNHLE9BQU8sSUFBSSx5QkFBQyxHQUFHLEdBQUssU0FBUyxHQUFFO0FBQ25DLENBQUM7QUFIRCwwQkFHQztBQUVELDJIQUEySDtBQUMzSCxxQkFBK0IsR0FBUTtJQUFFLHNCQUFrQztTQUFsQyxVQUFrQyxFQUFsQyxxQkFBa0MsRUFBbEMsSUFBa0M7UUFBbEMscUNBQWtDOztJQUN2RSxJQUFNLFNBQVMsR0FBRyxZQUFZLENBQUMsR0FBRyxDQUFDLFVBQUEsUUFBUSxJQUFJLE9BQUEsVUFBQyxDQUFJLEVBQUUsQ0FBSSxJQUFLLE9BQUEsQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUExQyxDQUEwQyxFQUExRCxDQUEwRCxDQUFDLENBQUM7SUFDM0csT0FBTyxJQUFJLHlCQUFDLEdBQUcsR0FBSyxTQUFTLEdBQUU7QUFDbkMsQ0FBQztBQUhELGtDQUdDO0FBRUQsNEpBQTRKO0FBQzVKLG1CQUE2QixVQUFnRTtJQUN6RixJQUFNLFFBQVEsR0FBRyxVQUFVLENBQUMsR0FBRyxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsWUFBWSxDQUFDLENBQUMsQ0FBQyxFQUFmLENBQWUsQ0FBQyxDQUFDO0lBQ3RELE9BQU8sUUFBUSxDQUFDLFNBQVMsRUFBRSxDQUFDO0FBQ2hDLENBQUM7QUFIRCw4QkFHQztBQU9ELHNCQUFnQyxLQUE0QztJQUN4RSxJQUFJLEtBQUssWUFBWSxFQUFFLENBQUMsVUFBVSxFQUFFO1FBQ2hDLE9BQU8sS0FBSyxDQUFDO0tBQ2hCO1NBQU07UUFDSCxPQUFPLEVBQUUsQ0FBQyxVQUFVLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztLQUM1RDtBQUNMLENBQUM7QUFORCxvQ0FNQztBQUVELCtDQUErQztBQUMvQyxjQUF3QixHQUFRLEVBQUUsS0FBYTtJQUMzQyxJQUFJLEdBQUcsR0FBUSxFQUFFLENBQUM7SUFDbEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUNsRCxHQUFHLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ3BCO0lBQ0QsT0FBTyxHQUFHLENBQUM7QUFDZixDQUFDO0FBTkQsb0JBTUM7QUFFRCxrRUFBa0U7QUFDbEUsa0JBQStCLEdBQVEsRUFBRSxTQUE0QixFQUFFLEdBQWdCO0lBQ25GLElBQU0sQ0FBQyxHQUFHLEtBQUssQ0FBQyxHQUFHLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDaEMsT0FBTyxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBQ3ZCLENBQUM7QUFIRCw0QkFHQztBQUVEOzs7O0dBSUc7QUFDSCwwQkFBMEMsR0FBUSxFQUFFLFFBQVcsRUFBRSxRQUFXLEVBQUUsV0FBMkI7SUFDckcsSUFBTSxRQUFRLEdBQUcsVUFBQyxDQUFJLEVBQUUsQ0FBSSxJQUFLLE9BQUEsYUFBYSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsRUFBRSxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBN0MsQ0FBNkMsQ0FBQztJQUMvRSxJQUFJLGFBQWEsR0FBRyxLQUFLLENBQUM7O1FBQzFCLEtBQW1CLElBQUEsUUFBQSxTQUFBLEdBQUcsQ0FBQSx3QkFBQTtZQUFqQixJQUFNLElBQUksZ0JBQUE7WUFDWCxJQUFJLFFBQVEsQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLEVBQUU7Z0JBQzFCLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLEVBQUU7b0JBQzlDLGFBQWEsR0FBRyxJQUFJLENBQUM7aUJBQ3hCO3FCQUFNO29CQUNILE9BQU8sSUFBSSxDQUFDO2lCQUNmO2FBQ0o7U0FDSjs7Ozs7Ozs7O0lBQ0QsT0FBTyxLQUFLLENBQUM7O0FBQ2pCLENBQUM7QUFiRCw0Q0FhQztBQUVEOzs7Ozs7R0FNRztBQUNILHlCQUF5QyxHQUFRLEVBQUUsUUFBVyxFQUFFLFdBQTJCO0lBQ3ZGLElBQU0sUUFBUSxHQUFHLFVBQUMsQ0FBSSxFQUFFLENBQUksSUFBSyxPQUFBLGFBQWEsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEVBQUUsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQTdDLENBQTZDLENBQUM7SUFDL0UsT0FBTyxRQUFRLENBQUMsR0FBRyxFQUFFLFFBQVEsRUFBRSxRQUFRLENBQUMsQ0FBQztBQUM3QyxDQUFDO0FBSEQsMENBR0M7QUFFRCwrRUFBK0U7QUFDL0UsbUJBQTBCLENBQU07SUFDNUIsT0FBTyxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsT0FBUSxDQUFzQixDQUFDLElBQUksQ0FBQyxJQUFJLFVBQVUsQ0FBQztBQUM1RSxDQUFDO0FBRkQsOEJBRUM7QUFFRCx5Q0FBeUM7QUFDekMsc0JBQTZCLENBQU07SUFDL0IsT0FBTyxDQUFDLFlBQVksRUFBRSxDQUFDLFVBQVUsQ0FBQztBQUN0QyxDQUFDO0FBRkQsb0NBRUM7QUFFRCxvQ0FBb0M7QUFDcEMsaUJBQXdCLENBQU07SUFDMUIsT0FBTyxDQUFDLFlBQVksS0FBSyxDQUFDO0FBQzlCLENBQUM7QUFGRCwwQkFFQztBQUVELDBEQUEwRDtBQUMxRCx1QkFBaUMsR0FBcUIsRUFBRSxTQUFZO0lBQ2hFLElBQU0sR0FBRyxHQUNMLEdBQUc7U0FDRSxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBOUIsQ0FBOEIsQ0FBQztTQUN4QyxJQUFJLENBQUMsVUFBQyxHQUFHLEVBQUUsR0FBRyxJQUFLLE9BQUEsQ0FBQyxFQUFFLElBQUksRUFBRSxHQUFHLENBQUMsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBcEMsQ0FBb0MsQ0FBQyxDQUFDO0lBQ2xFLE9BQU8sR0FBRyxDQUFDO0FBQ2YsQ0FBQztBQU5ELHNDQU1DO0FBRUQsOEVBQThFO0FBQzlFLHFCQUFtQyxLQUFVLEVBQUUsR0FBNkIsRUFBRSxPQUFVO0lBQ3BGLElBQUksSUFBSSxHQUFHLE9BQU8sQ0FBQztJQUNuQixJQUFJLEdBQUcsR0FBUyxFQUFFLENBQUM7O1FBQ25CLEtBQWlCLElBQUEsVUFBQSxTQUFBLEtBQUssQ0FBQSw0QkFBQTtZQUFqQixJQUFNLElBQUUsa0JBQUE7WUFDVCxHQUFHLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLEVBQUUsSUFBRSxDQUFDLENBQUMsQ0FBQztZQUN4QixJQUFJLEdBQUcsSUFBRSxDQUFDO1NBQ2I7Ozs7Ozs7OztJQUNELE9BQU8sR0FBRyxDQUFDOztBQUNmLENBQUM7QUFSRCxrQ0FRQztBQUVELGtFQUFrRTtBQUNsRSxzQkFBZ0QsS0FBWSxFQUFFLElBQVksRUFBRSxXQUFpRCxFQUFFLEdBQXVDO0lBQ2xLLElBQUksR0FBRyxHQUFXLEVBQUUsQ0FBQztJQUVyQixJQUFJLEtBQUssR0FBRyxJQUFJLENBQUM7O1FBQ2pCLEtBQWlCLElBQUEsVUFBQSxTQUFBLEtBQUssQ0FBQSw0QkFBQTtZQUFqQixJQUFNLElBQUUsa0JBQUE7WUFDVCxJQUFNLElBQUksR0FBRyxXQUFXLENBQUMsS0FBSyxFQUFFLElBQUUsQ0FBQyxDQUFDO1lBQ3BDLEtBQUssR0FBRyxJQUFJLENBQUM7WUFDYixJQUFNLE1BQU0sR0FBRyxHQUFHLENBQUMsS0FBSyxFQUFFLElBQUUsQ0FBQyxDQUFDO1lBRTlCLEdBQUcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7U0FDcEI7Ozs7Ozs7OztJQUNELE9BQU8sR0FBRyxDQUFDOztBQUNmLENBQUM7QUFaRCxvQ0FZQztBQUVELDZFQUE2RTtBQUM3RSxpQkFBK0IsS0FBVSxFQUFFLEdBQW1CO0lBQzFELElBQUksTUFBTSxHQUFTLEVBQUUsQ0FBQzs7UUFDdEIsS0FBZ0IsSUFBQSxVQUFBLFNBQUEsS0FBSyxDQUFBLDRCQUFBO1lBQWhCLElBQU0sQ0FBQyxrQkFBQTtZQUNSLElBQU0sU0FBUyxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUN6QixNQUFNLENBQUMsSUFBSSxPQUFYLE1BQU0sV0FBUyxTQUFTLEdBQUU7U0FDN0I7Ozs7Ozs7OztJQUNELE9BQU8sTUFBTSxDQUFDOztBQUNsQixDQUFDO0FBUEQsMEJBT0M7QUFFRCw0SEFBNEg7QUFDNUgsYUFBMkIsSUFBd0M7SUFDL0Qsc0RBQXNEO0lBQ3RELElBQU0sT0FBTyxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBZCxDQUFjLENBQUMsQ0FBQztJQUMxRCxJQUFJLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ3BCLE1BQU0sSUFBSSxLQUFLLENBQUMscURBQXFELENBQUMsQ0FBQztLQUMxRTtJQUNELElBQUksT0FBTyxDQUFDLE1BQU0sSUFBSSxDQUFDO1FBQUUsT0FBTyxFQUFFLENBQUM7SUFFbkMsSUFBTSxLQUFLLEdBQUcsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ3pCLElBQU0sR0FBRyxHQUFZLEVBQUUsQ0FBQzs0QkFDZixDQUFDO1FBQ04sSUFBTSxJQUFJLEdBQUcsU0FBUyxDQUFDLElBQUksRUFBRSxVQUFDLEtBQUssRUFBRSxHQUFHLElBQUssT0FBQyxLQUFlLENBQUMsQ0FBQyxDQUFDLEVBQW5CLENBQW1CLENBQUMsQ0FBQztRQUNsRSxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ25CLENBQUM7SUFIRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsS0FBSyxFQUFFLENBQUMsRUFBRTtnQkFBckIsQ0FBQztLQUdUO0lBQ0QsT0FBTyxHQUFHLENBQUM7QUFDZixDQUFDO0FBZkQsa0JBZUM7QUFFRCxnRkFBZ0Y7QUFDaEYseUJBQXlCLE9BQWUsRUFBRSxHQUFpQjtJQUFqQixvQkFBQSxFQUFBLFNBQWlCO0lBQ3ZELElBQUksT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDO1FBQ2xCLE9BQU8sT0FBTyxDQUFDO0lBRW5CLElBQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO0lBQ2pDLElBQUksR0FBRyxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ25DLEtBQUssSUFBSSxDQUFDLEdBQUcsS0FBSyxFQUFFLENBQUMsR0FBRyxPQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDNUMsSUFBTSxPQUFPLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUM7UUFDckMsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLENBQUM7S0FDN0M7SUFDRCxPQUFPLEdBQUcsQ0FBQztBQUNmLENBQUM7QUFFRDs7Ozs7OztHQU9HO0FBQ0gsc0JBQTZCLE1BQTBDLEVBQUUsT0FBbUIsRUFBRSxRQUFvQixFQUFFLE9BQXdCLEVBQUUsTUFBbUI7SUFBeEYsd0JBQUEsRUFBQSxXQUFtQjtJQUFFLHlCQUFBLEVBQUEsWUFBb0I7SUFBRSx3QkFBQSxFQUFBLGVBQXdCO0lBQUUsdUJBQUEsRUFBQSxXQUFtQjtJQUM3SixJQUFJLE1BQU0sSUFBSSxJQUFJO1FBQUUsT0FBTyxFQUFFLENBQUM7SUFDOUIsTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUV4QixJQUFNLE1BQU0sR0FBRyxzQkFBc0IsQ0FBQztJQUN0QyxJQUFNLElBQUksR0FBRyxNQUFNLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztJQUNuQyxJQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzNCLElBQU0sR0FBRyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDMUIsSUFBTSxJQUFJLEdBQUcsQ0FBQyxHQUFHLEdBQUcsQ0FBQztJQUVyQixJQUFNLE9BQU8sR0FBRyxFQUFFLEdBQUcsR0FBRyxDQUFDO0lBQ3pCLElBQU0sVUFBVSxHQUFHLE1BQU0sR0FBRyxPQUFPLENBQUM7SUFFcEMsSUFBTSxhQUFhLEdBQUcsVUFBVSxDQUFDLE1BQU0sQ0FBQyxVQUFVLENBQUMsTUFBTSxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO0lBQy9GLElBQU0sT0FBTyxHQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUMsZUFBZSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxhQUFhLENBQUM7SUFFekUsSUFBSSxRQUFRLElBQUksQ0FBQztRQUNiLE9BQU8sSUFBSSxHQUFHLE1BQU0sR0FBRyxPQUFPLENBQUM7SUFFbkMsSUFBTSxRQUFRLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLEdBQUcsSUFBSSxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFFLFFBQVEsQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7SUFDMUYsSUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsUUFBUSxHQUFHLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUNwRSxJQUFNLFdBQVcsR0FBRyxjQUFjLEdBQUcsUUFBUSxHQUFHLE1BQU0sQ0FBQztJQUN2RCxJQUFNLFFBQVEsR0FBRyxXQUFXLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUVwRCxPQUFPLElBQUksR0FBRyxNQUFNLEdBQUcsT0FBTyxHQUFHLEdBQUcsR0FBRyxRQUFRLENBQUM7QUFDcEQsQ0FBQztBQXpCRCxvQ0F5QkM7QUFVRCxxQkFBNEIsQ0FBNEI7SUFDcEQsT0FBTyxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUM7QUFDaEMsQ0FBQztBQUZELGtDQUVDO0FBRUQsSUFBTSxVQUFVLEdBQUcsQ0FBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3hHOztHQUVHO0FBQ0gsb0JBQTJCLENBQW1DLEVBQUUsWUFBc0I7SUFDbEYsSUFBSSxDQUFDLElBQUksSUFBSTtRQUFFLE9BQU8sRUFBRSxDQUFDO0lBQ3pCLENBQUMsR0FBRyxJQUFJLElBQUksQ0FBQyxDQUFRLENBQUMsQ0FBQztJQUV2QixJQUFNLElBQUksR0FBRyxZQUFZLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBQzlDLElBQU0sS0FBSyxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQztJQUN2QyxJQUFNLEdBQUcsR0FBRyxZQUFZLENBQUMsQ0FBQyxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBRXpDLElBQU0sS0FBSyxHQUFHLFlBQVksQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDNUMsSUFBTSxPQUFPLEdBQUcsWUFBWSxDQUFDLENBQUMsQ0FBQyxVQUFVLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQztJQUVoRCwrREFBK0Q7SUFDL0QsSUFBTSxPQUFPLEdBQUcsWUFBWSxJQUFJLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLElBQUksSUFBSSxJQUFJLE9BQU8sSUFBSSxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDO0lBRXpGLElBQU0sT0FBTyxHQUFHLEdBQUcsR0FBRyxHQUFHLEdBQUcsS0FBSyxHQUFHLEdBQUcsR0FBRyxJQUFJLENBQUM7SUFDL0MsSUFBSSxPQUFPLEVBQUU7UUFDVCxJQUFNLE9BQU8sR0FBRyxLQUFLLEdBQUcsR0FBRyxHQUFHLE9BQU8sQ0FBQztRQUN0QyxPQUFPLE9BQU8sR0FBRyxHQUFHLEdBQUcsT0FBTyxDQUFDO0tBQ2xDO1NBQU07UUFDSCxPQUFPLE9BQU8sQ0FBQztLQUNsQjtBQUNMLENBQUM7QUFyQkQsZ0NBcUJDO0FBRUQsc0VBQXNFO0FBQ3RFLHlCQUFnQyxDQUFPO0lBQ25DLElBQU0sQ0FBQyxHQUFHLFVBQUEsQ0FBQyxJQUFJLE9BQUEsWUFBWSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBbEIsQ0FBa0IsQ0FBQztJQUNsQyxJQUFNLEVBQUUsR0FBRyxVQUFBLENBQUMsSUFBSSxPQUFBLFlBQVksQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQWxCLENBQWtCLENBQUM7SUFFbkMsT0FBVSxFQUFFLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDLFNBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsR0FBRyxDQUFDLENBQUMsU0FBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sRUFBRSxDQUFDLFNBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxTQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxFQUFFLENBQUMsU0FBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLFVBQVUsRUFBRSxDQUFHLENBQUM7QUFDMUksQ0FBQztBQUxELDBDQUtDO0FBRUQsdUZBQXVGO0FBQ3ZGLHVCQUFpRSxJQUFPO0lBQ3BFLElBQU0sR0FBRyxHQUFHO1FBQUMsY0FBYzthQUFkLFVBQWMsRUFBZCxxQkFBYyxFQUFkLElBQWM7WUFBZCx5QkFBYzs7UUFBVSxPQUFBLElBQUksd0JBQUksSUFBSTtJQUFaLENBQWEsQ0FBQztJQUNuRCxJQUFNLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDOztRQUMvQixLQUFrQixJQUFBLFNBQUEsU0FBQSxJQUFJLENBQUEsMEJBQUE7WUFBakIsSUFBTSxHQUFHLGlCQUFBO1lBQ1YsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUN4Qjs7Ozs7Ozs7O0lBRUQsT0FBTyxHQUFRLENBQUM7O0FBQ3BCLENBQUM7QUFSRCxzQ0FRQztBQUVELElBQU0sZUFBZSxHQUFHLHNDQUFzQyxDQUFDO0FBRS9ELCtLQUErSztBQUMvSyxzQkFBZ0UsSUFBTyxFQUFFLE9BQWE7SUFBRSxrQkFBa0I7U0FBbEIsVUFBa0IsRUFBbEIscUJBQWtCLEVBQWxCLElBQWtCO1FBQWxCLGlDQUFrQjs7SUFDdEcsSUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMvQixJQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsSUFBSSxPQUFULElBQUksWUFBTSxPQUFPLEdBQUssUUFBUSxFQUFDLENBQUM7O1FBQzVDLEtBQWtCLElBQUEsU0FBQSxTQUFBLElBQUksQ0FBQSwwQkFBQTtZQUFqQixJQUFNLEdBQUcsaUJBQUE7WUFDVixHQUFHLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1NBQ3hCOzs7Ozs7Ozs7SUFBQSxDQUFDO0lBRUYsR0FBRyxDQUFDLGVBQWUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxlQUFlLENBQUMsSUFBSSxFQUFFLENBQUM7SUFDbEQsR0FBRyxDQUFDLGVBQWUsQ0FBQyxZQUFPLEdBQUcsQ0FBQyxlQUFlLENBQUMsR0FBRSxJQUFJLEVBQUMsQ0FBQztJQUV2RCxPQUFPLEdBQUcsQ0FBQzs7QUFDZixDQUFDO0FBWEQsb0NBV0M7QUFFRCx1TEFBdUw7QUFDdkwsd0JBQWtFLElBQU87SUFDckUsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBRTtRQUN4QixPQUFPLFNBQVMsQ0FBQztLQUNwQjtJQUNELElBQU0sR0FBRyxHQUFVLElBQUksQ0FBQyxlQUFlLENBQUMsQ0FBQztJQUN6QyxPQUFPLEdBQUcsQ0FBQyxHQUFHLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO0FBQy9CLENBQUM7QUFORCx3Q0FNQztBQUVELDBEQUEwRDtBQUMxRCxlQUFzQixFQUFVO0lBQzVCLE9BQU8sSUFBSSxPQUFPLENBQU8sVUFBQSxPQUFPLElBQUksT0FBQSxVQUFVLENBQUMsT0FBTyxFQUFFLEVBQUUsQ0FBQyxFQUF2QixDQUF1QixDQUFDLENBQUM7QUFDakUsQ0FBQztBQUZELHNCQUVDO0FBRUQsZ1BBQWdQO0FBQ2hQLDJCQUFrQyxDQUFRO0lBQ3RDLE1BQU0sSUFBSSxLQUFLLENBQUMsOEdBQThHLENBQUMsQ0FBQztBQUNwSSxDQUFDO0FBRkQsOENBRUM7QUFFRDs7R0FFRztBQUNILHNCQUFzQyxHQUFRLEVBQUUsV0FBMkIsRUFBRSxLQUFXLEVBQUUsUUFBdUM7SUFDN0gsSUFBTSxXQUFXLEdBQUcsUUFBUSxJQUFJLGVBQWUsQ0FBQztJQUNoRCxJQUFJLFFBQVEsR0FBRyxDQUFDLENBQUM7SUFDakIsSUFBSSxRQUFRLEdBQUcsR0FBRyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7SUFDOUIsSUFBSSxZQUFZLEdBQVcsQ0FBQyxDQUFDO0lBQzdCLElBQUksY0FBYyxDQUFDO0lBRW5CLE9BQU8sUUFBUSxJQUFJLFFBQVEsRUFBRTtRQUN6QixZQUFZLEdBQUcsQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUM3QyxjQUFjLEdBQUcsV0FBVyxDQUFDLEdBQUcsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDO1FBRWhELElBQU0sSUFBSSxHQUFHLFdBQVcsQ0FBQyxjQUFjLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFDaEQsSUFBSSxJQUFJLEdBQUcsQ0FBQyxFQUFFO1lBQ1YsUUFBUSxHQUFHLFlBQVksR0FBRyxDQUFDLENBQUM7U0FDL0I7YUFDSSxJQUFJLElBQUksR0FBRyxDQUFDLEVBQUU7WUFDZixRQUFRLEdBQUcsWUFBWSxHQUFHLENBQUMsQ0FBQztTQUMvQjthQUNJO1lBQ0QsT0FBTyxFQUFFLEtBQUssRUFBRSxZQUFZLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxDQUFDO1NBQy9DO0tBQ0o7SUFFRCxPQUFPLEVBQUUsS0FBSyxFQUFFLFFBQVEsR0FBRyxDQUFDLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxDQUFDO0FBQ2pELENBQUM7QUF4QkQsb0NBd0JDO0FBRUQ7Ozs7Ozs7R0FPRztBQUNILG1CQUFrQyxJQUFVLEVBQUUsS0FBVyxFQUFFLEtBQXVDO0lBQzlGLElBQUksR0FBRyxHQUE4QixFQUFFLENBQUM7O1FBQ3hDLEtBQWdCLElBQUEsU0FBQSxTQUFBLElBQUksQ0FBQSwwQkFBQTtZQUFmLElBQU0sQ0FBQyxpQkFBQTs7Z0JBQ1IsS0FBZ0IsSUFBQSxVQUFBLFNBQUEsS0FBSyxDQUFBLDRCQUFBO29CQUFoQixJQUFNLENBQUMsa0JBQUE7b0JBQ1IsSUFBSSxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxFQUFFO3dCQUNiLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLEVBQUUsQ0FBQyxDQUFDO3FCQUNuQztpQkFDSjs7Ozs7Ozs7O1NBQ0o7Ozs7Ozs7OztJQUNELE9BQU8sR0FBRyxDQUFDOztBQUNmLENBQUM7QUFWRCw4QkFVQztBQUVEOzs7Ozs7O0dBT0c7QUFDSCxrQkFBaUMsSUFBVSxFQUFFLEtBQVcsRUFBRSxLQUF1QztJQUM3RixJQUFJLEdBQUcsR0FBK0IsRUFBRSxDQUFDOztRQUN6QyxLQUFnQixJQUFBLFNBQUEsU0FBQSxJQUFJLENBQUEsMEJBQUE7WUFBZixJQUFNLENBQUMsaUJBQUE7WUFDUixJQUFJLFFBQVEsR0FBWSxLQUFLLENBQUM7O2dCQUM5QixLQUFnQixJQUFBLFVBQUEsU0FBQSxLQUFLLENBQUEsNEJBQUE7b0JBQWhCLElBQU0sQ0FBQyxrQkFBQTtvQkFDUixJQUFJLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQUU7d0JBQ2IsUUFBUSxHQUFHLElBQUksQ0FBQzt3QkFDaEIsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUM7cUJBQ25DO2lCQUNKOzs7Ozs7Ozs7WUFDRCxJQUFJLENBQUMsUUFBUSxFQUFFO2dCQUNYLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFFLENBQUMsQ0FBQzthQUN6QjtTQUNKOzs7Ozs7Ozs7SUFDRCxPQUFPLEdBQUcsQ0FBQzs7QUFDZixDQUFDO0FBZkQsNEJBZUM7QUFFRDs7Ozs7O0dBTUc7QUFDSCxxQkFBNEIsUUFBZ0IsRUFBRSxJQUFZLEVBQUUsUUFBc0IsRUFBRSxNQUFrQyxFQUFFLE9BQW9DO0lBQWhHLHlCQUFBLEVBQUEsY0FBc0I7SUFBRSx1QkFBQSxFQUFBLGFBQWtDO0lBQUUsd0JBQUEsRUFBQSxlQUFvQztJQUN4SixjQUFjLENBQVM7UUFDbkIsSUFBTSxLQUFLLEdBQUcsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDN0MsSUFBTSxHQUFHLEdBQUcsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDO1FBQzdELE9BQU8sQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsR0FBRyxHQUFHLEtBQUssQ0FBQyxDQUFDO0lBQ3hDLENBQUM7SUFFRCxJQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDcEMsSUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBRTVCLElBQU0sYUFBYSxHQUFHLFlBQVksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDbkQsSUFBTSxTQUFTLEdBQUcsUUFBUSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUUzQyxJQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsTUFBTSxHQUFHLENBQUMsSUFBSSxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBRXRFLElBQUksT0FBTyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUM7SUFDakQsSUFBSSxhQUFhLEdBQUcsS0FBSyxDQUFDO0lBQzFCLElBQUksUUFBUSxFQUFFOztZQUNWLEtBQW1CLElBQUEsY0FBQSxTQUFBLFNBQVMsQ0FBQSxvQ0FBQTtnQkFBdkIsSUFBTSxJQUFJLHNCQUFBO2dCQUNYLElBQUksSUFBSSxJQUFJLEdBQUcsSUFBSSxJQUFJLElBQUksSUFBSSxFQUFFO29CQUM3QixJQUFJLGFBQWE7d0JBQUUsTUFBTSxJQUFJLEtBQUssQ0FBQywyRUFBMkUsQ0FBQyxDQUFDO2lCQUNuSDtnQkFDRCxJQUFJLElBQUksSUFBSSxHQUFHLEVBQUU7b0JBQ2IsdUJBQXVCO2lCQUMxQjtxQkFBTSxJQUFJLElBQUksSUFBSSxJQUFJLEVBQUU7b0JBQ3JCLElBQU0sWUFBWSxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7b0JBQ3hDLE9BQU8sR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxZQUFZLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTtpQkFDMUU7cUJBQU07b0JBQ0gsYUFBYSxHQUFHLElBQUksQ0FBQztvQkFDckIsT0FBTyxJQUFJLE9BQU8sSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDLENBQUM7aUJBQ3ZEO2FBQ0o7Ozs7Ozs7OztLQUNKO0lBRUQsSUFBTSxxQkFBcUIsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDaEYsSUFBTSx3QkFBd0IsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBRXpELCtCQUErQjtJQUMvQixJQUFJLE1BQU0sSUFBSSxJQUFJLElBQUksQ0FBQyxNQUFNLEtBQUssU0FBUyxJQUFJLHFCQUFxQixDQUFDLEVBQUU7UUFDbkUsT0FBTyxHQUFHLFFBQVEsR0FBRyxPQUFPLENBQUM7S0FDaEM7SUFDRCxJQUFJLE9BQU8sSUFBSSxJQUFJLElBQUksQ0FBQyxPQUFPLEtBQUssU0FBUyxJQUFJLHdCQUF3QixDQUFDLEVBQUU7UUFDeEUsT0FBTyxHQUFHLE9BQU8sR0FBRyxRQUFRLENBQUM7S0FDaEM7SUFDRCxPQUFPLE9BQU8sQ0FBQzs7QUFDbkIsQ0FBQztBQTdDRCxrQ0E2Q0M7QUFFRDs7R0FFRztBQUNILGFBQW9CLEdBQWtDO0lBQ2xELE9BQU8sR0FBRyxDQUFDLE1BQU0sQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsSUFBSSxJQUFJLEVBQVQsQ0FBUyxDQUFDLENBQUMsR0FBRyxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBRSxFQUFGLENBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxVQUFDLENBQUMsRUFBRSxDQUFDLElBQUssT0FBQSxDQUFDLEdBQUcsQ0FBQyxFQUFMLENBQUssRUFBRSxDQUFDLENBQUMsQ0FBQztBQUM5RSxDQUFDO0FBRkQsa0JBRUM7QUFFRDs7RUFFRTtBQUNGLHVCQUFpQyxHQUFxQjtJQUNsRCxPQUFPLElBQUksT0FBTyxDQUFJLFVBQUMsT0FBTyxFQUFFLE1BQU0sSUFBSyxPQUFBLEdBQUcsQ0FBQyxTQUFTLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxFQUE5QixDQUE4QixDQUFDLENBQUM7QUFDL0UsQ0FBQztBQUZELHNDQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/keautils/dist/logic.js
// module id = 491
// module chunks = 0